/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CenterUpdate,
  CheckDuplicateOrgItemcode,
  CompanyInput,
  FcmTopicRequest,
  HTTPValidationError,
  MasterItemUpdate,
  MstCalendarCenterSupplierUpdate,
  MstCalendarUpdate,
  MstCenterStockItemUpdate,
  MstCenterSupplierUpdate,
  MstCustomerCenterUpdate,
  MstCustomerUpdate,
  MstSupplierUpate,
  MstTransportRelationUpdate,
  MstTransportTypeUpdate,
  MstUserInput,
  OrderPlanTransportLotUpdate,
  ResponseAlertCenterStockItem,
  ResponseAlertMstItem,
  ResponseAlertSummary,
  ResponseCalendar,
  ResponseCalendarCenterSupplier,
  ResponseCenter,
  ResponseCenterStockItem,
  ResponseCenterSupplier,
  ResponseCompany,
  ResponseCustomer,
  ResponseCustomerCenter,
  ResponseFcmTopic,
  ResponseInfoMessage,
  ResponseItem,
  ResponseLoginUser,
  ResponseMonthReport,
  ResponseOrderAlert,
  ResponseResult,
  ResponseShipExpected,
  ResponseShipExpectedCustomer,
  ResponseStock,
  ResponseSupplier,
  ResponseTransportRelation,
  ResponseTransportType,
  ResponseType,
  ResponseTypecode,
  ResponseUpdate,
  ResponseUserCreate,
  ResponseUserSearch,
  ResponseUserUpdate,
  SearchTargetEnabled,
  ShipExclusionUpdate,
  StockPlanUpdate,
  StockUpdate,
} from '../models/index';
import {
    CenterUpdateFromJSON,
    CenterUpdateToJSON,
    CheckDuplicateOrgItemcodeFromJSON,
    CheckDuplicateOrgItemcodeToJSON,
    CompanyInputFromJSON,
    CompanyInputToJSON,
    FcmTopicRequestFromJSON,
    FcmTopicRequestToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    MasterItemUpdateFromJSON,
    MasterItemUpdateToJSON,
    MstCalendarCenterSupplierUpdateFromJSON,
    MstCalendarCenterSupplierUpdateToJSON,
    MstCalendarUpdateFromJSON,
    MstCalendarUpdateToJSON,
    MstCenterStockItemUpdateFromJSON,
    MstCenterStockItemUpdateToJSON,
    MstCenterSupplierUpdateFromJSON,
    MstCenterSupplierUpdateToJSON,
    MstCustomerCenterUpdateFromJSON,
    MstCustomerCenterUpdateToJSON,
    MstCustomerUpdateFromJSON,
    MstCustomerUpdateToJSON,
    MstSupplierUpateFromJSON,
    MstSupplierUpateToJSON,
    MstTransportRelationUpdateFromJSON,
    MstTransportRelationUpdateToJSON,
    MstTransportTypeUpdateFromJSON,
    MstTransportTypeUpdateToJSON,
    MstUserInputFromJSON,
    MstUserInputToJSON,
    OrderPlanTransportLotUpdateFromJSON,
    OrderPlanTransportLotUpdateToJSON,
    ResponseAlertCenterStockItemFromJSON,
    ResponseAlertCenterStockItemToJSON,
    ResponseAlertMstItemFromJSON,
    ResponseAlertMstItemToJSON,
    ResponseAlertSummaryFromJSON,
    ResponseAlertSummaryToJSON,
    ResponseCalendarFromJSON,
    ResponseCalendarToJSON,
    ResponseCalendarCenterSupplierFromJSON,
    ResponseCalendarCenterSupplierToJSON,
    ResponseCenterFromJSON,
    ResponseCenterToJSON,
    ResponseCenterStockItemFromJSON,
    ResponseCenterStockItemToJSON,
    ResponseCenterSupplierFromJSON,
    ResponseCenterSupplierToJSON,
    ResponseCompanyFromJSON,
    ResponseCompanyToJSON,
    ResponseCustomerFromJSON,
    ResponseCustomerToJSON,
    ResponseCustomerCenterFromJSON,
    ResponseCustomerCenterToJSON,
    ResponseFcmTopicFromJSON,
    ResponseFcmTopicToJSON,
    ResponseInfoMessageFromJSON,
    ResponseInfoMessageToJSON,
    ResponseItemFromJSON,
    ResponseItemToJSON,
    ResponseLoginUserFromJSON,
    ResponseLoginUserToJSON,
    ResponseMonthReportFromJSON,
    ResponseMonthReportToJSON,
    ResponseOrderAlertFromJSON,
    ResponseOrderAlertToJSON,
    ResponseResultFromJSON,
    ResponseResultToJSON,
    ResponseShipExpectedFromJSON,
    ResponseShipExpectedToJSON,
    ResponseShipExpectedCustomerFromJSON,
    ResponseShipExpectedCustomerToJSON,
    ResponseStockFromJSON,
    ResponseStockToJSON,
    ResponseSupplierFromJSON,
    ResponseSupplierToJSON,
    ResponseTransportRelationFromJSON,
    ResponseTransportRelationToJSON,
    ResponseTransportTypeFromJSON,
    ResponseTransportTypeToJSON,
    ResponseTypeFromJSON,
    ResponseTypeToJSON,
    ResponseTypecodeFromJSON,
    ResponseTypecodeToJSON,
    ResponseUpdateFromJSON,
    ResponseUpdateToJSON,
    ResponseUserCreateFromJSON,
    ResponseUserCreateToJSON,
    ResponseUserSearchFromJSON,
    ResponseUserSearchToJSON,
    ResponseUserUpdateFromJSON,
    ResponseUserUpdateToJSON,
    SearchTargetEnabledFromJSON,
    SearchTargetEnabledToJSON,
    ShipExclusionUpdateFromJSON,
    ShipExclusionUpdateToJSON,
    StockPlanUpdateFromJSON,
    StockPlanUpdateToJSON,
    StockUpdateFromJSON,
    StockUpdateToJSON,
} from '../models/index';

export interface CheckDuplicateOrgItemCodeCheckMasterItemOrgItemCodePostRequest {
    checkDuplicateOrgItemcode: CheckDuplicateOrgItemcode;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface CreateCompanyCompanyCreatePostRequest {
    companyInput: CompanyInput;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface CreateUserUserCreatePostRequest {
    mstUserInput: MstUserInput;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface DlCsvDownloadCsvDataTypeGetRequest {
    dataType: string;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface DlShipExpectedCsvDownloadCsvShipExpectedGetRequest {
    companyId: number;
    viewDateType?: string | null;
    viewUnitType?: string | null;
    startDate?: Date | null;
    offset?: number | null;
    centerId?: number | null;
    itemCode?: string | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface DlShipExpectedXlsxDownloadXlsxShipExpectedGetRequest {
    companyId: number;
    viewDateType?: string | null;
    viewUnitType?: string | null;
    startDate?: Date | null;
    offset?: number | null;
    centerId?: number | null;
    itemCode?: string | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface DlStockCsvDownloadCsvStockGetRequest {
    companyId: number;
    sort?: Array<string>;
    centerId?: number | null;
    centerIds?: Array<number> | null;
    orgCenterId?: number | null;
    orgSupplierId?: string | null;
    orgSupplierIds?: Array<string> | null;
    itemCode?: string | null;
    itemCodes?: Array<string> | null;
    startDate?: Date | null;
    viewUnitType?: string | null;
    dateRange?: string | null;
    endDate?: Date | null;
    renewal?: boolean | null;
    orderPlanFlg?: boolean;
    getPeriodDataFlg?: boolean;
    startDateTypeCode?: string | null;
    endDateTypeCode?: string | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface DlStockXlsxDownloadXlsxStockGetRequest {
    companyId: number;
    sort?: Array<string>;
    centerId?: number | null;
    centerIds?: Array<number> | null;
    orgCenterId?: number | null;
    orgSupplierId?: string | null;
    orgSupplierIds?: Array<string> | null;
    itemCode?: string | null;
    itemCodes?: Array<string> | null;
    startDate?: Date | null;
    viewUnitType?: string | null;
    dateRange?: string | null;
    endDate?: Date | null;
    renewal?: boolean | null;
    orderPlanFlg?: boolean;
    getPeriodDataFlg?: boolean;
    startDateTypeCode?: string | null;
    endDateTypeCode?: string | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface DlXlsxDownloadXlsxDataTypeGetRequest {
    dataType: string;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface ExecOptimizeExecOptimizeGetRequest {
    companyId?: number | null;
    centerId?: number | null;
    targetType?: string | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface FcmSubscribeFcmSubscribePostRequest {
    fcmTopicRequest: FcmTopicRequest;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface FcmUnsubscribeFcmUnsubscribePostRequest {
    fcmTopicRequest: FcmTopicRequest;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface GetAlertCenterStockItemCenterStockItemAlertGetRequest {
    companyId: number;
    sort?: Array<string>;
    limit?: number | null;
    pageNo?: number | null;
    enabled?: boolean | null;
    centerId?: number | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface GetAlertMstItemsItemAlertGetRequest {
    companyId: number;
    sort?: Array<string>;
    limit?: number | null;
    pageNo?: number | null;
    enabled?: boolean | null;
    orgSupplierId?: string | null;
    supplierCompanyId?: number | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface GetAlertSummaryAlertSummaryGetRequest {
    sort?: Array<string>;
    limit?: number | null;
    pageNo?: number | null;
    enabled?: boolean | null;
    centerId?: number | null;
    orgSupplierId?: string | null;
    centerIds?: Array<number> | null;
    orgSupplierIds?: Array<string> | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface GetInfomessageInfomessageGetRequest {
    sort?: Array<string>;
    limit?: number | null;
    pageNo?: number | null;
    enabled?: boolean | null;
    companyId?: number | null;
    processType?: string | null;
    target?: string | null;
    infoType?: string | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface GetMonthReportMonthReportGetRequest {
    sort?: Array<string>;
    limit?: number | null;
    pageNo?: number | null;
    enabled?: boolean | null;
    centerId?: number | null;
    orgSupplierId?: string | null;
    itemCode?: string | null;
    startDate?: Date | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface GetMstCalendarCalendarGetRequest {
    companyId: number;
    sort?: Array<string>;
    limit?: number | null;
    pageNo?: number | null;
    enabled?: boolean | null;
    orgCenterId?: string | null;
    calendarDate?: Date | null;
    enableShip?: boolean | null;
    enableArrival?: boolean | null;
    enableOrder?: boolean | null;
    arrivalRatio?: number | null;
    selectDateRange?: string | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface GetMstCalendarCenterSupplierCalendarCenterSupplierGetRequest {
    companyId: number;
    sort?: Array<string>;
    limit?: number | null;
    pageNo?: number | null;
    enabled?: boolean | null;
    orgCenterId?: string | null;
    orgSupplierId?: string | null;
    calendarDate?: Date | null;
    enableSupplierShipday?: boolean | null;
    enableOrderday?: boolean | null;
    arrivalRatio?: number | null;
    selectDateRange?: string | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface GetMstCenterStockItemCenterStockItemGetRequest {
    companyId: number;
    sort?: Array<string>;
    limit?: number | null;
    pageNo?: number | null;
    enabled?: boolean | null;
    centerId?: number | null;
    centerIds?: Array<number> | null;
    itemCode?: string | null;
    orgItemCode?: string | null;
    orgSupplierId?: string | null;
    orgSupplierIds?: Array<string> | null;
    supplierCompanyId?: number | null;
    searchTargetEnabled?: SearchTargetEnabled | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface GetMstCenterSupplierCenterSupplierGetRequest {
    companyId: number;
    sort?: Array<string>;
    limit?: number | null;
    pageNo?: number | null;
    enabled?: boolean | null;
    centerId?: number | null;
    orgSupplierId?: string | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface GetMstCentersCenterGetRequest {
    companyId: number;
    sort?: Array<string>;
    limit?: number | null;
    pageNo?: number | null;
    enabled?: boolean | null;
    centerId?: number | null;
    orgCenterId?: string | null;
    centerName?: string | null;
    centerGroupName?: string | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface GetMstCustomersCenterCustomerCenterGetRequest {
    companyId: number;
    sort?: Array<string>;
    limit?: number | null;
    pageNo?: number | null;
    enabled?: boolean | null;
    orgCustomerId?: string | null;
    orgCustomerCenterId?: string | null;
    customerCenterName?: string | null;
    customerCenterAddress?: string | null;
    customerCenterGln?: string | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface GetMstCustomersCustomerGetRequest {
    companyId: number;
    sort?: Array<string>;
    limit?: number | null;
    pageNo?: number | null;
    enabled?: boolean | null;
    customerCompanyId?: number | null;
    orgCustomerId?: string | null;
    customerName?: string | null;
    customerHojinNo?: string | null;
    customerGln?: string | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface GetMstItemsItemGetRequest {
    companyId: number;
    sort?: Array<string>;
    limit?: number | null;
    pageNo?: number | null;
    enabled?: boolean | null;
    itemCode?: string | null;
    itemName?: string | null;
    orgItemCode?: string | null;
    orgSupplierId?: string | null;
    supplierCompanyId?: number | null;
    barcode?: string | null;
    searchTargetEnabled?: SearchTargetEnabled | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface GetMstSuppliersSupplierGetRequest {
    companyId: number;
    sort?: Array<string>;
    limit?: number | null;
    pageNo?: number | null;
    enabled?: boolean | null;
    supplierCompanyId?: number | null;
    orgSupplierId?: string | null;
    supplierName?: string | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface GetMstTransportRelationTransportRelationGetRequest {
    companyId: number;
    sort?: Array<string>;
    limit?: number | null;
    pageNo?: number | null;
    enabled?: boolean | null;
    centerId?: number | null;
    orgCenterId?: string | null;
    orgCustomerId?: string | null;
    orgCustomerCenterId?: string | null;
    leadtime?: number | null;
    maxTrafficVolume?: number | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface GetMstTransportTypeTransportTypeGetRequest {
    companyId: number;
    sort?: Array<string>;
    limit?: number | null;
    pageNo?: number | null;
    enabled?: boolean | null;
    transportTypeId?: number | null;
    transportTypeName?: string | null;
    maxWeight?: number | null;
    maxPalletCount?: number | null;
    remarks?: string | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface GetOrderAlertOrderAlertGetRequest {
    sort?: Array<string>;
    limit?: number | null;
    pageNo?: number | null;
    enabled?: boolean | null;
    centerId?: number | null;
    orgSupplierId?: string | null;
    centerIds?: Array<number> | null;
    orgSupplierIds?: Array<string> | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface GetShipExpectedCustomerShipExpectedCustomerGetRequest {
    companyId: number;
    viewDateType?: string | null;
    viewUnitType?: string | null;
    startDate?: Date | null;
    offset?: number | null;
    centerId?: number | null;
    itemCode?: string | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface GetShipExpectedShipExpectedGetRequest {
    companyId: number;
    viewDateType?: string | null;
    viewUnitType?: string | null;
    startDate?: Date | null;
    offset?: number | null;
    centerId?: number | null;
    itemCode?: string | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface GetStockStockGetRequest {
    companyId: number;
    sort?: Array<string>;
    centerId?: number | null;
    centerIds?: Array<number> | null;
    orgCenterId?: number | null;
    orgSupplierId?: string | null;
    orgSupplierIds?: Array<string> | null;
    itemCode?: string | null;
    itemCodes?: Array<string> | null;
    startDate?: Date | null;
    viewUnitType?: string | null;
    dateRange?: string | null;
    endDate?: Date | null;
    renewal?: boolean | null;
    orderPlanFlg?: boolean;
    getPeriodDataFlg?: boolean;
    startDateTypeCode?: string | null;
    endDateTypeCode?: string | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface GetSysTypecodeTypecodeGetRequest {
    sort?: Array<string>;
    limit?: number | null;
    pageNo?: number | null;
    enabled?: boolean | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface MasterCalendarCenterSupplierUpdateCalendarCenterSupplierUpdatePostRequest {
    mstCalendarCenterSupplierUpdate: MstCalendarCenterSupplierUpdate;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface MasterCalendarUpdateMstCalendarUpdatePostRequest {
    mstCalendarUpdate: MstCalendarUpdate;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface MasterCenterStockItemUpdateMstCenterStockItemUpdatePostRequest {
    mstCenterStockItemUpdate: MstCenterStockItemUpdate;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface MasterCenterUpdateMasterCenterUpdatePostRequest {
    centerUpdate: CenterUpdate;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface MasterCustomerCenterUpdateMstCustomerCenterUpdatePostRequest {
    mstCustomerCenterUpdate: MstCustomerCenterUpdate;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface MasterCustomerUpdateMasterCustomerUpdatePostRequest {
    mstCustomerUpdate: MstCustomerUpdate;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface MasterItemUpdateMasterItemUpdatePostRequest {
    masterItemUpdate: MasterItemUpdate;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface MasterSupplierUpdateMasterSupplierUpdatePostRequest {
    mstSupplierUpate: MstSupplierUpate;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface MasterTransportRelationUpdateMstTransportRelationUpdatePostRequest {
    mstTransportRelationUpdate: MstTransportRelationUpdate;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface MasterTransportTypeUpdateMstTransportTypeUpdatePostRequest {
    mstTransportTypeUpdate: MstTransportTypeUpdate;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface MstCenterSupplierUpdateCenterSupplierUpdatePostRequest {
    mstCenterSupplierUpdate: MstCenterSupplierUpdate;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface OptimizeResultUpdateStockUpdatePostRequest {
    stockUpdate: StockUpdate;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface OrderPlanTransportLotUpdateOrderPlanTransportLotUpdatePostRequest {
    orderPlanTransportLotUpdate: OrderPlanTransportLotUpdate;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface ReadCompanyCompanySearchGetRequest {
    sort?: Array<string>;
    limit?: number | null;
    pageNo?: number | null;
    enabled?: boolean | null;
    companyId?: number | null;
    tenantId?: string | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface ReadUsersUserSearchGetRequest {
    sort?: Array<string>;
    limit?: number | null;
    pageNo?: number | null;
    enabled?: boolean | null;
    companyId?: number | null;
    userMail?: string | null;
    tenantId?: string | null;
    userId?: string | null;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface SavePostUploadDataTypePostRequest {
    dataType: string;
    postedFile: Blob;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface ShipExclusionUpdateShipExclusionUpdatePostRequest {
    shipExclusionUpdate: ShipExclusionUpdate;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface StockPlanUpdateStockPlanUpdatePostRequest {
    stockPlanUpdate: StockPlanUpdate;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface StockUpdateUploadStockPlanUploadPostRequest {
    postedFile: Blob;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface UpdateCompanyCompanyUpdatePostRequest {
    companyInput: CompanyInput;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

export interface UpdateUserUserUpdatePostRequest {
    mstUserInput: MstUserInput;
    xCompanyId?: string | null;
    xTenantId?: string | null;
    xUserId?: string | null;
    xSystemDate?: string | null;
    xUserAuth?: string | null;
    xSystemStatus?: string | null;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * 入出荷数量調整更新
     */
    async checkDuplicateOrgItemCodeCheckMasterItemOrgItemCodePostRaw(requestParameters: CheckDuplicateOrgItemCodeCheckMasterItemOrgItemCodePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['checkDuplicateOrgItemcode'] == null) {
            throw new runtime.RequiredError(
                'checkDuplicateOrgItemcode',
                'Required parameter "checkDuplicateOrgItemcode" was null or undefined when calling checkDuplicateOrgItemCodeCheckMasterItemOrgItemCodePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/check/master-item/org-item-code`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CheckDuplicateOrgItemcodeToJSON(requestParameters['checkDuplicateOrgItemcode']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * 入出荷数量調整更新
     */
    async checkDuplicateOrgItemCodeCheckMasterItemOrgItemCodePost(requestParameters: CheckDuplicateOrgItemCodeCheckMasterItemOrgItemCodePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.checkDuplicateOrgItemCodeCheckMasterItemOrgItemCodePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ユーザ企業作成 - **テーブル**: mst_company - company_idはパラメーターで渡されたIDを使用 - ログインユーザーの権限チェック 作成不可の場合は権限エラー     - x_user_auth=99 : 作成可     - それ以外 : 作成不可 - mst_companyに企業作成     - 企業IDの新規作成 - Identity Platformにテナントの作成     - テナント名の命名規則 : corp-{企業ID} - Identity Platformに登録したテナントIDを取得 - mst_companyのテナントID更新
     * ユーザ企業作成
     */
    async createCompanyCompanyCreatePostRaw(requestParameters: CreateCompanyCompanyCreatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUpdate>> {
        if (requestParameters['companyInput'] == null) {
            throw new runtime.RequiredError(
                'companyInput',
                'Required parameter "companyInput" was null or undefined when calling createCompanyCompanyCreatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/company/create`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompanyInputToJSON(requestParameters['companyInput']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUpdateFromJSON(jsonValue));
    }

    /**
     * ユーザ企業作成 - **テーブル**: mst_company - company_idはパラメーターで渡されたIDを使用 - ログインユーザーの権限チェック 作成不可の場合は権限エラー     - x_user_auth=99 : 作成可     - それ以外 : 作成不可 - mst_companyに企業作成     - 企業IDの新規作成 - Identity Platformにテナントの作成     - テナント名の命名規則 : corp-{企業ID} - Identity Platformに登録したテナントIDを取得 - mst_companyのテナントID更新
     * ユーザ企業作成
     */
    async createCompanyCompanyCreatePost(requestParameters: CreateCompanyCompanyCreatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUpdate> {
        const response = await this.createCompanyCompanyCreatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ユーザマスタ: - **テーブル**: mst_user - company_idはパラメーターで渡されたIDを使用 - ログインユーザーの権限チェック 作成不可の場合は権限エラー     - x_user_auth=99 : 作成可     - x_user_auth=9 : company_id=x_company_idの場合のみ作成可     - それ以外 : 作成不可 - 同一テナント内に、おなじメールアドレスのユーザーが存在しないことを確認（存在する場合はエラー） - Identity Platformの対象テナントにユーザー作成（user_mail・初期パスワードはダミー（ランダムで設定）） - Identity Platformに登録したユーザーIDを取得 - ユーザーマスタにレコード作成 - パスワード変更のメールを送信
     * ユーザ作成
     */
    async createUserUserCreatePostRaw(requestParameters: CreateUserUserCreatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUserCreate>> {
        if (requestParameters['mstUserInput'] == null) {
            throw new runtime.RequiredError(
                'mstUserInput',
                'Required parameter "mstUserInput" was null or undefined when calling createUserUserCreatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/create`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MstUserInputToJSON(requestParameters['mstUserInput']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUserCreateFromJSON(jsonValue));
    }

    /**
     * ユーザマスタ: - **テーブル**: mst_user - company_idはパラメーターで渡されたIDを使用 - ログインユーザーの権限チェック 作成不可の場合は権限エラー     - x_user_auth=99 : 作成可     - x_user_auth=9 : company_id=x_company_idの場合のみ作成可     - それ以外 : 作成不可 - 同一テナント内に、おなじメールアドレスのユーザーが存在しないことを確認（存在する場合はエラー） - Identity Platformの対象テナントにユーザー作成（user_mail・初期パスワードはダミー（ランダムで設定）） - Identity Platformに登録したユーザーIDを取得 - ユーザーマスタにレコード作成 - パスワード変更のメールを送信
     * ユーザ作成
     */
    async createUserUserCreatePost(requestParameters: CreateUserUserCreatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUserCreate> {
        const response = await this.createUserUserCreatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * {data_type}で指定されたファイルをCSVファイルダウンロード   - テーブルからデータを取得してダウンロード場合     - mst_center - 上記以外は、ストレージ領域の対象のフォルダから、指定されたファイルを取得してダウンロード     - ファイル: {バケット}/download/{x_tenant_id}/{data_type}.csv     - 対象ファイルがない場合、エラーレスポンスを返す         - 対象ファイルがありません。アップロード後、ダウンロード可能になるまで暫くかかります。
     * 汎用ダウンロード（CSV）
     */
    async dlCsvDownloadCsvDataTypeGetRaw(requestParameters: DlCsvDownloadCsvDataTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dataType'] == null) {
            throw new runtime.RequiredError(
                'dataType',
                'Required parameter "dataType" was null or undefined when calling dlCsvDownloadCsvDataTypeGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/download/csv/{data_type}`;
        urlPath = urlPath.replace(`{${"data_type"}}`, encodeURIComponent(String(requestParameters['dataType'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * {data_type}で指定されたファイルをCSVファイルダウンロード   - テーブルからデータを取得してダウンロード場合     - mst_center - 上記以外は、ストレージ領域の対象のフォルダから、指定されたファイルを取得してダウンロード     - ファイル: {バケット}/download/{x_tenant_id}/{data_type}.csv     - 対象ファイルがない場合、エラーレスポンスを返す         - 対象ファイルがありません。アップロード後、ダウンロード可能になるまで暫くかかります。
     * 汎用ダウンロード（CSV）
     */
    async dlCsvDownloadCsvDataTypeGet(requestParameters: DlCsvDownloadCsvDataTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.dlCsvDownloadCsvDataTypeGetRaw(requestParameters, initOverrides);
    }

    /**
     * ```     select             ship.company_id             ,ship.center_id             ,mst_center.center_name             ,ship.item_code             ,item_name             ,ship.customer_company_id             ,coalesce(ref_shipto_all.customer_name,\'非参加企業\') as customer_company_name             ,ship.customer_center_id             ,coalesce(ref_shipto_all.customer_center_name ,\'\') as customer_center_name             ,ship.expected_rank             ,ship.ship_date             ,ship.quantity             ,ship.order_date             ,ship.leadtime             ,ship.max_traffic_volume             ,ship.order_quantity_recommend             ,ship.ship_quantity_expected             ,ship.order_quantity_reason             ,ship.order_quantity_plan     from func_ship_data(:company_id,:center_id, :tr_date, :item_code) ship     inner join mst_item on mst_item.company_id = ship.company_id      inner join ref_mst_item on ref_mst_item.company_id = mst_item.company_id                             AND ref_mst_item.org_item_code = mst_item.org_item_code                             AND ref_mst_item.item_code = ship.item_code     left join mst_center on mst_center.company_id =ship.company_id and mst_center.center_id  =ship.center_id     left join ref_shipto_all on ref_shipto_all.company_id=ship.company_id and ref_shipto_all.center_id=ship.center_id                     and ref_shipto_all.customer_company_id=ship.customer_company_id and ref_shipto_all.customer_center_id=ship.customer_center_id     order by             ship.company_id             ,ship.center_id             ,ship.item_code             ,ship.customer_company_id             ,ship.customer_center_id             ,ship.ship_date ```
     * 需要予測ダウンロード
     */
    async dlShipExpectedCsvDownloadCsvShipExpectedGetRaw(requestParameters: DlShipExpectedCsvDownloadCsvShipExpectedGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling dlShipExpectedCsvDownloadCsvShipExpectedGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['viewDateType'] != null) {
            queryParameters['view_date_type'] = requestParameters['viewDateType'];
        }

        if (requestParameters['viewUnitType'] != null) {
            queryParameters['view_unit_type'] = requestParameters['viewUnitType'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = requestParameters['startDate'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['centerId'] != null) {
            queryParameters['center_id'] = requestParameters['centerId'];
        }

        if (requestParameters['itemCode'] != null) {
            queryParameters['item_code'] = requestParameters['itemCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/download/csv/ship-expected`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ```     select             ship.company_id             ,ship.center_id             ,mst_center.center_name             ,ship.item_code             ,item_name             ,ship.customer_company_id             ,coalesce(ref_shipto_all.customer_name,\'非参加企業\') as customer_company_name             ,ship.customer_center_id             ,coalesce(ref_shipto_all.customer_center_name ,\'\') as customer_center_name             ,ship.expected_rank             ,ship.ship_date             ,ship.quantity             ,ship.order_date             ,ship.leadtime             ,ship.max_traffic_volume             ,ship.order_quantity_recommend             ,ship.ship_quantity_expected             ,ship.order_quantity_reason             ,ship.order_quantity_plan     from func_ship_data(:company_id,:center_id, :tr_date, :item_code) ship     inner join mst_item on mst_item.company_id = ship.company_id      inner join ref_mst_item on ref_mst_item.company_id = mst_item.company_id                             AND ref_mst_item.org_item_code = mst_item.org_item_code                             AND ref_mst_item.item_code = ship.item_code     left join mst_center on mst_center.company_id =ship.company_id and mst_center.center_id  =ship.center_id     left join ref_shipto_all on ref_shipto_all.company_id=ship.company_id and ref_shipto_all.center_id=ship.center_id                     and ref_shipto_all.customer_company_id=ship.customer_company_id and ref_shipto_all.customer_center_id=ship.customer_center_id     order by             ship.company_id             ,ship.center_id             ,ship.item_code             ,ship.customer_company_id             ,ship.customer_center_id             ,ship.ship_date ```
     * 需要予測ダウンロード
     */
    async dlShipExpectedCsvDownloadCsvShipExpectedGet(requestParameters: DlShipExpectedCsvDownloadCsvShipExpectedGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.dlShipExpectedCsvDownloadCsvShipExpectedGetRaw(requestParameters, initOverrides);
    }

    /**
     * 需要予測ダウンロード
     */
    async dlShipExpectedXlsxDownloadXlsxShipExpectedGetRaw(requestParameters: DlShipExpectedXlsxDownloadXlsxShipExpectedGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling dlShipExpectedXlsxDownloadXlsxShipExpectedGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['viewDateType'] != null) {
            queryParameters['view_date_type'] = requestParameters['viewDateType'];
        }

        if (requestParameters['viewUnitType'] != null) {
            queryParameters['view_unit_type'] = requestParameters['viewUnitType'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = requestParameters['startDate'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['centerId'] != null) {
            queryParameters['center_id'] = requestParameters['centerId'];
        }

        if (requestParameters['itemCode'] != null) {
            queryParameters['item_code'] = requestParameters['itemCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/download/xlsx/ship-expected`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 需要予測ダウンロード
     */
    async dlShipExpectedXlsxDownloadXlsxShipExpectedGet(requestParameters: DlShipExpectedXlsxDownloadXlsxShipExpectedGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.dlShipExpectedXlsxDownloadXlsxShipExpectedGetRaw(requestParameters, initOverrides);
    }

    /**
     * /stock のデータをCSVファイルでダウンロード
     * センター商品別入出荷在庫ダウンロード（CSV）
     */
    async dlStockCsvDownloadCsvStockGetRaw(requestParameters: DlStockCsvDownloadCsvStockGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUpdate>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling dlStockCsvDownloadCsvStockGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['centerId'] != null) {
            queryParameters['center_id'] = requestParameters['centerId'];
        }

        if (requestParameters['centerIds'] != null) {
            queryParameters['center_ids'] = requestParameters['centerIds'];
        }

        if (requestParameters['orgCenterId'] != null) {
            queryParameters['org_center_id'] = requestParameters['orgCenterId'];
        }

        if (requestParameters['orgSupplierId'] != null) {
            queryParameters['org_supplier_id'] = requestParameters['orgSupplierId'];
        }

        if (requestParameters['orgSupplierIds'] != null) {
            queryParameters['org_supplier_ids'] = requestParameters['orgSupplierIds'];
        }

        if (requestParameters['itemCode'] != null) {
            queryParameters['item_code'] = requestParameters['itemCode'];
        }

        if (requestParameters['itemCodes'] != null) {
            queryParameters['item_codes'] = requestParameters['itemCodes'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = requestParameters['startDate'];
        }

        if (requestParameters['viewUnitType'] != null) {
            queryParameters['view_unit_type'] = requestParameters['viewUnitType'];
        }

        if (requestParameters['dateRange'] != null) {
            queryParameters['date_range'] = requestParameters['dateRange'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['end_date'] = requestParameters['endDate'];
        }

        if (requestParameters['renewal'] != null) {
            queryParameters['renewal'] = requestParameters['renewal'];
        }

        if (requestParameters['orderPlanFlg'] != null) {
            queryParameters['order_plan_flg'] = requestParameters['orderPlanFlg'];
        }

        if (requestParameters['getPeriodDataFlg'] != null) {
            queryParameters['get_period_data_flg'] = requestParameters['getPeriodDataFlg'];
        }

        if (requestParameters['startDateTypeCode'] != null) {
            queryParameters['start_date_type_code'] = requestParameters['startDateTypeCode'];
        }

        if (requestParameters['endDateTypeCode'] != null) {
            queryParameters['end_date_type_code'] = requestParameters['endDateTypeCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/download/csv/stock`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUpdateFromJSON(jsonValue));
    }

    /**
     * /stock のデータをCSVファイルでダウンロード
     * センター商品別入出荷在庫ダウンロード（CSV）
     */
    async dlStockCsvDownloadCsvStockGet(requestParameters: DlStockCsvDownloadCsvStockGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUpdate> {
        const response = await this.dlStockCsvDownloadCsvStockGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * /stock のデータをエクセルファイルでダウンロード
     * センター商品別入出荷在庫ダウンロード（エクセル）
     */
    async dlStockXlsxDownloadXlsxStockGetRaw(requestParameters: DlStockXlsxDownloadXlsxStockGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUpdate>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling dlStockXlsxDownloadXlsxStockGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['centerId'] != null) {
            queryParameters['center_id'] = requestParameters['centerId'];
        }

        if (requestParameters['centerIds'] != null) {
            queryParameters['center_ids'] = requestParameters['centerIds'];
        }

        if (requestParameters['orgCenterId'] != null) {
            queryParameters['org_center_id'] = requestParameters['orgCenterId'];
        }

        if (requestParameters['orgSupplierId'] != null) {
            queryParameters['org_supplier_id'] = requestParameters['orgSupplierId'];
        }

        if (requestParameters['orgSupplierIds'] != null) {
            queryParameters['org_supplier_ids'] = requestParameters['orgSupplierIds'];
        }

        if (requestParameters['itemCode'] != null) {
            queryParameters['item_code'] = requestParameters['itemCode'];
        }

        if (requestParameters['itemCodes'] != null) {
            queryParameters['item_codes'] = requestParameters['itemCodes'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = requestParameters['startDate'];
        }

        if (requestParameters['viewUnitType'] != null) {
            queryParameters['view_unit_type'] = requestParameters['viewUnitType'];
        }

        if (requestParameters['dateRange'] != null) {
            queryParameters['date_range'] = requestParameters['dateRange'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['end_date'] = requestParameters['endDate'];
        }

        if (requestParameters['renewal'] != null) {
            queryParameters['renewal'] = requestParameters['renewal'];
        }

        if (requestParameters['orderPlanFlg'] != null) {
            queryParameters['order_plan_flg'] = requestParameters['orderPlanFlg'];
        }

        if (requestParameters['getPeriodDataFlg'] != null) {
            queryParameters['get_period_data_flg'] = requestParameters['getPeriodDataFlg'];
        }

        if (requestParameters['startDateTypeCode'] != null) {
            queryParameters['start_date_type_code'] = requestParameters['startDateTypeCode'];
        }

        if (requestParameters['endDateTypeCode'] != null) {
            queryParameters['end_date_type_code'] = requestParameters['endDateTypeCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/download/xlsx/stock`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUpdateFromJSON(jsonValue));
    }

    /**
     * /stock のデータをエクセルファイルでダウンロード
     * センター商品別入出荷在庫ダウンロード（エクセル）
     */
    async dlStockXlsxDownloadXlsxStockGet(requestParameters: DlStockXlsxDownloadXlsxStockGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUpdate> {
        const response = await this.dlStockXlsxDownloadXlsxStockGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * {data_type}で指定されたファイルをダウンロード   ※ CSVダウンロードを参照
     * 汎用ダウンロード（エクセル）
     */
    async dlXlsxDownloadXlsxDataTypeGetRaw(requestParameters: DlXlsxDownloadXlsxDataTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dataType'] == null) {
            throw new runtime.RequiredError(
                'dataType',
                'Required parameter "dataType" was null or undefined when calling dlXlsxDownloadXlsxDataTypeGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/download/xlsx/{data_type}`;
        urlPath = urlPath.replace(`{${"data_type"}}`, encodeURIComponent(String(requestParameters['dataType'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * {data_type}で指定されたファイルをダウンロード   ※ CSVダウンロードを参照
     * 汎用ダウンロード（エクセル）
     */
    async dlXlsxDownloadXlsxDataTypeGet(requestParameters: DlXlsxDownloadXlsxDataTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.dlXlsxDownloadXlsxDataTypeGetRaw(requestParameters, initOverrides);
    }

    /**
     * 任意のタイミングで、発注推奨数算出処理を開始  - todo:ワークフロー実施中の場合は、エラーを通知して終了(2024-03 ph3機能追加) - 平準化処理用ワークフローに対象のcompany_id、center_idを付与して実行     - company_idはx_company_idを使用 - sys_infomessageに処理開始メッセージを登録 - ResponseResult     - status     - message : 発注推奨数算出処理を実行しました。しばらくお待ちください。 -  -  -  -
     * 発注推奨数算出実行指示
     */
    async execOptimizeExecOptimizeGetRaw(requestParameters: ExecOptimizeExecOptimizeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseType>> {
        const queryParameters: any = {};

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['centerId'] != null) {
            queryParameters['center_id'] = requestParameters['centerId'];
        }

        if (requestParameters['targetType'] != null) {
            queryParameters['target_type'] = requestParameters['targetType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/exec/optimize`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseTypeFromJSON(jsonValue));
    }

    /**
     * 任意のタイミングで、発注推奨数算出処理を開始  - todo:ワークフロー実施中の場合は、エラーを通知して終了(2024-03 ph3機能追加) - 平準化処理用ワークフローに対象のcompany_id、center_idを付与して実行     - company_idはx_company_idを使用 - sys_infomessageに処理開始メッセージを登録 - ResponseResult     - status     - message : 発注推奨数算出処理を実行しました。しばらくお待ちください。 -  -  -  -
     * 発注推奨数算出実行指示
     */
    async execOptimizeExecOptimizeGet(requestParameters: ExecOptimizeExecOptimizeGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseType> {
        const response = await this.execOptimizeExecOptimizeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ログイン後にフロントエンドから呼び出す。 デバイスの FCM トークンを `company_{company_id}` トピックに登録する。 DB への書き込みは不要。
     * FCM Topic サブスクライブ
     */
    async fcmSubscribeFcmSubscribePostRaw(requestParameters: FcmSubscribeFcmSubscribePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseFcmTopic>> {
        if (requestParameters['fcmTopicRequest'] == null) {
            throw new runtime.RequiredError(
                'fcmTopicRequest',
                'Required parameter "fcmTopicRequest" was null or undefined when calling fcmSubscribeFcmSubscribePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/fcm/subscribe`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FcmTopicRequestToJSON(requestParameters['fcmTopicRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseFcmTopicFromJSON(jsonValue));
    }

    /**
     * ログイン後にフロントエンドから呼び出す。 デバイスの FCM トークンを `company_{company_id}` トピックに登録する。 DB への書き込みは不要。
     * FCM Topic サブスクライブ
     */
    async fcmSubscribeFcmSubscribePost(requestParameters: FcmSubscribeFcmSubscribePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseFcmTopic> {
        const response = await this.fcmSubscribeFcmSubscribePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ログアウト時にフロントエンドから呼び出す。 デバイスの FCM トークンをトピックから削除する。
     * FCM Topic アンサブスクライブ
     */
    async fcmUnsubscribeFcmUnsubscribePostRaw(requestParameters: FcmUnsubscribeFcmUnsubscribePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseFcmTopic>> {
        if (requestParameters['fcmTopicRequest'] == null) {
            throw new runtime.RequiredError(
                'fcmTopicRequest',
                'Required parameter "fcmTopicRequest" was null or undefined when calling fcmUnsubscribeFcmUnsubscribePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/fcm/unsubscribe`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FcmTopicRequestToJSON(requestParameters['fcmTopicRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseFcmTopicFromJSON(jsonValue));
    }

    /**
     * ログアウト時にフロントエンドから呼び出す。 デバイスの FCM トークンをトピックから削除する。
     * FCM Topic アンサブスクライブ
     */
    async fcmUnsubscribeFcmUnsubscribePost(requestParameters: FcmUnsubscribeFcmUnsubscribePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseFcmTopic> {
        const response = await this.fcmUnsubscribeFcmUnsubscribePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * センター在庫管理マスタアラート一覧  以下の①と②をUNIONして取得 - ① マスタ未登録：ref_mst_center_stock_item.master_not_found=true かつ   センター在庫管理マスタ（mst_center_stock_item）に存在しないコード - ② マスタ登録ありで、アラートがあるコード：func_mst_center_stock_item.is_alert=true
     * センター在庫管理マスタアラート検索
     */
    async getAlertCenterStockItemCenterStockItemAlertGetRaw(requestParameters: GetAlertCenterStockItemCenterStockItemAlertGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseAlertCenterStockItem>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getAlertCenterStockItemCenterStockItemAlertGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['pageNo'] != null) {
            queryParameters['page_no'] = requestParameters['pageNo'];
        }

        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['centerId'] != null) {
            queryParameters['center_id'] = requestParameters['centerId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/center-stock-item-alert`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseAlertCenterStockItemFromJSON(jsonValue));
    }

    /**
     * センター在庫管理マスタアラート一覧  以下の①と②をUNIONして取得 - ① マスタ未登録：ref_mst_center_stock_item.master_not_found=true かつ   センター在庫管理マスタ（mst_center_stock_item）に存在しないコード - ② マスタ登録ありで、アラートがあるコード：func_mst_center_stock_item.is_alert=true
     * センター在庫管理マスタアラート検索
     */
    async getAlertCenterStockItemCenterStockItemAlertGet(requestParameters: GetAlertCenterStockItemCenterStockItemAlertGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseAlertCenterStockItem> {
        const response = await this.getAlertCenterStockItemCenterStockItemAlertGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 商品マスタアラート:  - 削除フラグ・取扱終了・通知停止がすべてfalseの商品を対象 - ref_mst_item.master_not_found=true の未登録コード - item APIと同一判定で is_alert=true の登録済みコード
     * 商品マスタアラート検索
     */
    async getAlertMstItemsItemAlertGetRaw(requestParameters: GetAlertMstItemsItemAlertGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseAlertMstItem>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getAlertMstItemsItemAlertGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['pageNo'] != null) {
            queryParameters['page_no'] = requestParameters['pageNo'];
        }

        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['orgSupplierId'] != null) {
            queryParameters['org_supplier_id'] = requestParameters['orgSupplierId'];
        }

        if (requestParameters['supplierCompanyId'] != null) {
            queryParameters['supplier_company_id'] = requestParameters['supplierCompanyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/item-alert`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseAlertMstItemFromJSON(jsonValue));
    }

    /**
     * 商品マスタアラート:  - 削除フラグ・取扱終了・通知停止がすべてfalseの商品を対象 - ref_mst_item.master_not_found=true の未登録コード - item APIと同一判定で is_alert=true の登録済みコード
     * 商品マスタアラート検索
     */
    async getAlertMstItemsItemAlertGet(requestParameters: GetAlertMstItemsItemAlertGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseAlertMstItem> {
        const response = await this.getAlertMstItemsItemAlertGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ``` アラート情報取得 - is_order_alert     - 取得先：func_stock_data     - データ取得範囲：rec_date>=本日 and order_limit_date<=本日     - 以下のいずれかにTrueがあるレコードが存在する場合はTrue             - 前日在庫引当不可：alert_ship_previous_stock         - 在庫ゼロ以下：alert_out_of_stock         - 在庫量低下（欠品リスク）：alert_low_stock - is_mst_center_stock_item_alert     - いずれかに該当するレコードがある場合はTrue     - func_mst_center_stock_item.is_alert     - ref_mst_center_stock_item.master_not_found=trueで、センター在庫管理マスタに存在しないコード - is_mst_item_alert     - ref_mst_item.master_not_found=trueで、商品マスタに存在しないコードがある場合はTrue  ```
     * アラート情報取得
     */
    async getAlertSummaryAlertSummaryGetRaw(requestParameters: GetAlertSummaryAlertSummaryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseAlertSummary>> {
        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['pageNo'] != null) {
            queryParameters['page_no'] = requestParameters['pageNo'];
        }

        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }

        if (requestParameters['centerId'] != null) {
            queryParameters['center_id'] = requestParameters['centerId'];
        }

        if (requestParameters['orgSupplierId'] != null) {
            queryParameters['org_supplier_id'] = requestParameters['orgSupplierId'];
        }

        if (requestParameters['centerIds'] != null) {
            queryParameters['center_ids'] = requestParameters['centerIds'];
        }

        if (requestParameters['orgSupplierIds'] != null) {
            queryParameters['org_supplier_ids'] = requestParameters['orgSupplierIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/alert-summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseAlertSummaryFromJSON(jsonValue));
    }

    /**
     * ``` アラート情報取得 - is_order_alert     - 取得先：func_stock_data     - データ取得範囲：rec_date>=本日 and order_limit_date<=本日     - 以下のいずれかにTrueがあるレコードが存在する場合はTrue             - 前日在庫引当不可：alert_ship_previous_stock         - 在庫ゼロ以下：alert_out_of_stock         - 在庫量低下（欠品リスク）：alert_low_stock - is_mst_center_stock_item_alert     - いずれかに該当するレコードがある場合はTrue     - func_mst_center_stock_item.is_alert     - ref_mst_center_stock_item.master_not_found=trueで、センター在庫管理マスタに存在しないコード - is_mst_item_alert     - ref_mst_item.master_not_found=trueで、商品マスタに存在しないコードがある場合はTrue  ```
     * アラート情報取得
     */
    async getAlertSummaryAlertSummaryGet(requestParameters: GetAlertSummaryAlertSummaryGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseAlertSummary> {
        const response = await this.getAlertSummaryAlertSummaryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * sys_infomessageからデータを取得  - 検索条件のcompany_idはx_company_idを使用する - 区分マスタから名称に変換
     * お知らせ取得
     */
    async getInfomessageInfomessageGetRaw(requestParameters: GetInfomessageInfomessageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseInfoMessage>> {
        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['pageNo'] != null) {
            queryParameters['page_no'] = requestParameters['pageNo'];
        }

        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['processType'] != null) {
            queryParameters['process_type'] = requestParameters['processType'];
        }

        if (requestParameters['target'] != null) {
            queryParameters['target'] = requestParameters['target'];
        }

        if (requestParameters['infoType'] != null) {
            queryParameters['info_type'] = requestParameters['infoType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/infomessage`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseInfoMessageFromJSON(jsonValue));
    }

    /**
     * sys_infomessageからデータを取得  - 検索条件のcompany_idはx_company_idを使用する - 区分マスタから名称に変換
     * お知らせ取得
     */
    async getInfomessageInfomessageGet(requestParameters: GetInfomessageInfomessageGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseInfoMessage> {
        const response = await this.getInfomessageInfomessageGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 月次データ取得 - **テーブル**: t_month_report_center_item
     * ダッシュボード月次データ取得
     */
    async getMonthReportMonthReportGetRaw(requestParameters: GetMonthReportMonthReportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseMonthReport>> {
        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['pageNo'] != null) {
            queryParameters['page_no'] = requestParameters['pageNo'];
        }

        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }

        if (requestParameters['centerId'] != null) {
            queryParameters['center_id'] = requestParameters['centerId'];
        }

        if (requestParameters['orgSupplierId'] != null) {
            queryParameters['org_supplier_id'] = requestParameters['orgSupplierId'];
        }

        if (requestParameters['itemCode'] != null) {
            queryParameters['item_code'] = requestParameters['itemCode'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = requestParameters['startDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/month-report`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseMonthReportFromJSON(jsonValue));
    }

    /**
     * 月次データ取得 - **テーブル**: t_month_report_center_item
     * ダッシュボード月次データ取得
     */
    async getMonthReportMonthReportGet(requestParameters: GetMonthReportMonthReportGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseMonthReport> {
        const response = await this.getMonthReportMonthReportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Mst Calendar
     */
    async getMstCalendarCalendarGetRaw(requestParameters: GetMstCalendarCalendarGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseCalendar>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getMstCalendarCalendarGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['pageNo'] != null) {
            queryParameters['page_no'] = requestParameters['pageNo'];
        }

        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['orgCenterId'] != null) {
            queryParameters['org_center_id'] = requestParameters['orgCenterId'];
        }

        if (requestParameters['calendarDate'] != null) {
            queryParameters['calendar_date'] = requestParameters['calendarDate'];
        }

        if (requestParameters['enableShip'] != null) {
            queryParameters['enable_ship'] = requestParameters['enableShip'];
        }

        if (requestParameters['enableArrival'] != null) {
            queryParameters['enable_arrival'] = requestParameters['enableArrival'];
        }

        if (requestParameters['enableOrder'] != null) {
            queryParameters['enable_order'] = requestParameters['enableOrder'];
        }

        if (requestParameters['arrivalRatio'] != null) {
            queryParameters['arrival_ratio'] = requestParameters['arrivalRatio'];
        }

        if (requestParameters['selectDateRange'] != null) {
            queryParameters['select_date_range'] = requestParameters['selectDateRange'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/calendar`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseCalendarFromJSON(jsonValue));
    }

    /**
     * Get Mst Calendar
     */
    async getMstCalendarCalendarGet(requestParameters: GetMstCalendarCalendarGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseCalendar> {
        const response = await this.getMstCalendarCalendarGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * カレンダーセンター仕入先検索
     */
    async getMstCalendarCenterSupplierCalendarCenterSupplierGetRaw(requestParameters: GetMstCalendarCenterSupplierCalendarCenterSupplierGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseCalendarCenterSupplier>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getMstCalendarCenterSupplierCalendarCenterSupplierGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['pageNo'] != null) {
            queryParameters['page_no'] = requestParameters['pageNo'];
        }

        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['orgCenterId'] != null) {
            queryParameters['org_center_id'] = requestParameters['orgCenterId'];
        }

        if (requestParameters['orgSupplierId'] != null) {
            queryParameters['org_supplier_id'] = requestParameters['orgSupplierId'];
        }

        if (requestParameters['calendarDate'] != null) {
            queryParameters['calendar_date'] = requestParameters['calendarDate'];
        }

        if (requestParameters['enableSupplierShipday'] != null) {
            queryParameters['enable_supplier_shipday'] = requestParameters['enableSupplierShipday'];
        }

        if (requestParameters['enableOrderday'] != null) {
            queryParameters['enable_orderday'] = requestParameters['enableOrderday'];
        }

        if (requestParameters['arrivalRatio'] != null) {
            queryParameters['arrival_ratio'] = requestParameters['arrivalRatio'];
        }

        if (requestParameters['selectDateRange'] != null) {
            queryParameters['select_date_range'] = requestParameters['selectDateRange'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/calendar-center-supplier`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseCalendarCenterSupplierFromJSON(jsonValue));
    }

    /**
     * カレンダーセンター仕入先検索
     */
    async getMstCalendarCenterSupplierCalendarCenterSupplierGet(requestParameters: GetMstCalendarCenterSupplierCalendarCenterSupplierGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseCalendarCenterSupplier> {
        const response = await this.getMstCalendarCenterSupplierCalendarCenterSupplierGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Mst Center Stock Item
     */
    async getMstCenterStockItemCenterStockItemGetRaw(requestParameters: GetMstCenterStockItemCenterStockItemGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseCenterStockItem>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getMstCenterStockItemCenterStockItemGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['pageNo'] != null) {
            queryParameters['page_no'] = requestParameters['pageNo'];
        }

        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['centerId'] != null) {
            queryParameters['center_id'] = requestParameters['centerId'];
        }

        if (requestParameters['centerIds'] != null) {
            queryParameters['center_ids'] = requestParameters['centerIds'];
        }

        if (requestParameters['itemCode'] != null) {
            queryParameters['item_code'] = requestParameters['itemCode'];
        }

        if (requestParameters['orgItemCode'] != null) {
            queryParameters['org_item_code'] = requestParameters['orgItemCode'];
        }

        if (requestParameters['orgSupplierId'] != null) {
            queryParameters['org_supplier_id'] = requestParameters['orgSupplierId'];
        }

        if (requestParameters['orgSupplierIds'] != null) {
            queryParameters['org_supplier_ids'] = requestParameters['orgSupplierIds'];
        }

        if (requestParameters['supplierCompanyId'] != null) {
            queryParameters['supplier_company_id'] = requestParameters['supplierCompanyId'];
        }

        if (requestParameters['searchTargetEnabled'] != null) {
            queryParameters['search_target_enabled'] = requestParameters['searchTargetEnabled'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/center-stock-item`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseCenterStockItemFromJSON(jsonValue));
    }

    /**
     * Get Mst Center Stock Item
     */
    async getMstCenterStockItemCenterStockItemGet(requestParameters: GetMstCenterStockItemCenterStockItemGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseCenterStockItem> {
        const response = await this.getMstCenterStockItemCenterStockItemGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Mst Center Supplier
     */
    async getMstCenterSupplierCenterSupplierGetRaw(requestParameters: GetMstCenterSupplierCenterSupplierGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseCenterSupplier>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getMstCenterSupplierCenterSupplierGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['pageNo'] != null) {
            queryParameters['page_no'] = requestParameters['pageNo'];
        }

        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }

        if (requestParameters['centerId'] != null) {
            queryParameters['center_id'] = requestParameters['centerId'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['orgSupplierId'] != null) {
            queryParameters['org_supplier_id'] = requestParameters['orgSupplierId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/center-supplier`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseCenterSupplierFromJSON(jsonValue));
    }

    /**
     * Get Mst Center Supplier
     */
    async getMstCenterSupplierCenterSupplierGet(requestParameters: GetMstCenterSupplierCenterSupplierGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseCenterSupplier> {
        const response = await this.getMstCenterSupplierCenterSupplierGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * センターマスタ検索 - **テーブル**: mst_center - **デフォルトソート**:     - company_id     - center_group_name     - org_center_id
     * センターマスタ検索
     */
    async getMstCentersCenterGetRaw(requestParameters: GetMstCentersCenterGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseCenter>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getMstCentersCenterGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['pageNo'] != null) {
            queryParameters['page_no'] = requestParameters['pageNo'];
        }

        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }

        if (requestParameters['centerId'] != null) {
            queryParameters['center_id'] = requestParameters['centerId'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['orgCenterId'] != null) {
            queryParameters['org_center_id'] = requestParameters['orgCenterId'];
        }

        if (requestParameters['centerName'] != null) {
            queryParameters['center_name'] = requestParameters['centerName'];
        }

        if (requestParameters['centerGroupName'] != null) {
            queryParameters['center_group_name'] = requestParameters['centerGroupName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/center`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseCenterFromJSON(jsonValue));
    }

    /**
     * センターマスタ検索 - **テーブル**: mst_center - **デフォルトソート**:     - company_id     - center_group_name     - org_center_id
     * センターマスタ検索
     */
    async getMstCentersCenterGet(requestParameters: GetMstCentersCenterGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseCenter> {
        const response = await this.getMstCentersCenterGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 得意先マスタ検索
     */
    async getMstCustomersCenterCustomerCenterGetRaw(requestParameters: GetMstCustomersCenterCustomerCenterGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseCustomerCenter>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getMstCustomersCenterCustomerCenterGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['pageNo'] != null) {
            queryParameters['page_no'] = requestParameters['pageNo'];
        }

        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['orgCustomerId'] != null) {
            queryParameters['org_customer_id'] = requestParameters['orgCustomerId'];
        }

        if (requestParameters['orgCustomerCenterId'] != null) {
            queryParameters['org_customer_center_id'] = requestParameters['orgCustomerCenterId'];
        }

        if (requestParameters['customerCenterName'] != null) {
            queryParameters['customer_center_name'] = requestParameters['customerCenterName'];
        }

        if (requestParameters['customerCenterAddress'] != null) {
            queryParameters['customer_center_address'] = requestParameters['customerCenterAddress'];
        }

        if (requestParameters['customerCenterGln'] != null) {
            queryParameters['customer_center_gln'] = requestParameters['customerCenterGln'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/customer-center`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseCustomerCenterFromJSON(jsonValue));
    }

    /**
     * 得意先マスタ検索
     */
    async getMstCustomersCenterCustomerCenterGet(requestParameters: GetMstCustomersCenterCustomerCenterGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseCustomerCenter> {
        const response = await this.getMstCustomersCenterCustomerCenterGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 得意先マスタ検索
     */
    async getMstCustomersCustomerGetRaw(requestParameters: GetMstCustomersCustomerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseCustomer>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getMstCustomersCustomerGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['pageNo'] != null) {
            queryParameters['page_no'] = requestParameters['pageNo'];
        }

        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['customerCompanyId'] != null) {
            queryParameters['customer_company_id'] = requestParameters['customerCompanyId'];
        }

        if (requestParameters['orgCustomerId'] != null) {
            queryParameters['org_customer_id'] = requestParameters['orgCustomerId'];
        }

        if (requestParameters['customerName'] != null) {
            queryParameters['customer_name'] = requestParameters['customerName'];
        }

        if (requestParameters['customerHojinNo'] != null) {
            queryParameters['customer_hojin_no'] = requestParameters['customerHojinNo'];
        }

        if (requestParameters['customerGln'] != null) {
            queryParameters['customer_gln'] = requestParameters['customerGln'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/customer`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseCustomerFromJSON(jsonValue));
    }

    /**
     * 得意先マスタ検索
     */
    async getMstCustomersCustomerGet(requestParameters: GetMstCustomersCustomerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseCustomer> {
        const response = await this.getMstCustomersCustomerGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 商品マスタ:  - **テーブル**: mst_item - **デフォルトソート**:     - company_id     - item_name     - sales_startdate desc *** バーコード検索 ```sql (:barcode =any(array[mst_item.jan, mst_item.jan_case, mst_item.gtin_13, mst_item.gtin_14, mst_item.itf]) or :barcode is null) ```  order_unit_type_nameは、区分マスタから変換 ``` select ~~~ ,sys_typecode.type_name as order_unit_type_name from ~~~ left join sys_typecode on sys_typecode.type_group=\'order_unit_type\' and sys_typecode.type_code= mst_item.order_unit_type ```
     * 商品マスタ検索
     */
    async getMstItemsItemGetRaw(requestParameters: GetMstItemsItemGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseItem>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getMstItemsItemGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['pageNo'] != null) {
            queryParameters['page_no'] = requestParameters['pageNo'];
        }

        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['itemCode'] != null) {
            queryParameters['item_code'] = requestParameters['itemCode'];
        }

        if (requestParameters['itemName'] != null) {
            queryParameters['item_name'] = requestParameters['itemName'];
        }

        if (requestParameters['orgItemCode'] != null) {
            queryParameters['org_item_code'] = requestParameters['orgItemCode'];
        }

        if (requestParameters['orgSupplierId'] != null) {
            queryParameters['org_supplier_id'] = requestParameters['orgSupplierId'];
        }

        if (requestParameters['supplierCompanyId'] != null) {
            queryParameters['supplier_company_id'] = requestParameters['supplierCompanyId'];
        }

        if (requestParameters['barcode'] != null) {
            queryParameters['barcode'] = requestParameters['barcode'];
        }

        if (requestParameters['searchTargetEnabled'] != null) {
            queryParameters['search_target_enabled'] = requestParameters['searchTargetEnabled'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/item`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseItemFromJSON(jsonValue));
    }

    /**
     * 商品マスタ:  - **テーブル**: mst_item - **デフォルトソート**:     - company_id     - item_name     - sales_startdate desc *** バーコード検索 ```sql (:barcode =any(array[mst_item.jan, mst_item.jan_case, mst_item.gtin_13, mst_item.gtin_14, mst_item.itf]) or :barcode is null) ```  order_unit_type_nameは、区分マスタから変換 ``` select ~~~ ,sys_typecode.type_name as order_unit_type_name from ~~~ left join sys_typecode on sys_typecode.type_group=\'order_unit_type\' and sys_typecode.type_code= mst_item.order_unit_type ```
     * 商品マスタ検索
     */
    async getMstItemsItemGet(requestParameters: GetMstItemsItemGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseItem> {
        const response = await this.getMstItemsItemGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 仕入先マスタ
     */
    async getMstSuppliersSupplierGetRaw(requestParameters: GetMstSuppliersSupplierGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseSupplier>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getMstSuppliersSupplierGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['pageNo'] != null) {
            queryParameters['page_no'] = requestParameters['pageNo'];
        }

        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['supplierCompanyId'] != null) {
            queryParameters['supplier_company_id'] = requestParameters['supplierCompanyId'];
        }

        if (requestParameters['orgSupplierId'] != null) {
            queryParameters['org_supplier_id'] = requestParameters['orgSupplierId'];
        }

        if (requestParameters['supplierName'] != null) {
            queryParameters['supplier_name'] = requestParameters['supplierName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/supplier`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseSupplierFromJSON(jsonValue));
    }

    /**
     * 仕入先マスタ
     */
    async getMstSuppliersSupplierGet(requestParameters: GetMstSuppliersSupplierGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseSupplier> {
        const response = await this.getMstSuppliersSupplierGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Mst Transport Relation
     */
    async getMstTransportRelationTransportRelationGetRaw(requestParameters: GetMstTransportRelationTransportRelationGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseTransportRelation>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getMstTransportRelationTransportRelationGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['pageNo'] != null) {
            queryParameters['page_no'] = requestParameters['pageNo'];
        }

        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['centerId'] != null) {
            queryParameters['center_id'] = requestParameters['centerId'];
        }

        if (requestParameters['orgCenterId'] != null) {
            queryParameters['org_center_id'] = requestParameters['orgCenterId'];
        }

        if (requestParameters['orgCustomerId'] != null) {
            queryParameters['org_customer_id'] = requestParameters['orgCustomerId'];
        }

        if (requestParameters['orgCustomerCenterId'] != null) {
            queryParameters['org_customer_center_id'] = requestParameters['orgCustomerCenterId'];
        }

        if (requestParameters['leadtime'] != null) {
            queryParameters['leadtime'] = requestParameters['leadtime'];
        }

        if (requestParameters['maxTrafficVolume'] != null) {
            queryParameters['max_traffic_volume'] = requestParameters['maxTrafficVolume'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/transport-relation`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseTransportRelationFromJSON(jsonValue));
    }

    /**
     * Get Mst Transport Relation
     */
    async getMstTransportRelationTransportRelationGet(requestParameters: GetMstTransportRelationTransportRelationGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseTransportRelation> {
        const response = await this.getMstTransportRelationTransportRelationGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Mst Transport Type
     */
    async getMstTransportTypeTransportTypeGetRaw(requestParameters: GetMstTransportTypeTransportTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseTransportType>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getMstTransportTypeTransportTypeGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['pageNo'] != null) {
            queryParameters['page_no'] = requestParameters['pageNo'];
        }

        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }

        if (requestParameters['transportTypeId'] != null) {
            queryParameters['transport_type_id'] = requestParameters['transportTypeId'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['transportTypeName'] != null) {
            queryParameters['transport_type_name'] = requestParameters['transportTypeName'];
        }

        if (requestParameters['maxWeight'] != null) {
            queryParameters['max_weight'] = requestParameters['maxWeight'];
        }

        if (requestParameters['maxPalletCount'] != null) {
            queryParameters['max_pallet_count'] = requestParameters['maxPalletCount'];
        }

        if (requestParameters['remarks'] != null) {
            queryParameters['remarks'] = requestParameters['remarks'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/transport-type`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseTransportTypeFromJSON(jsonValue));
    }

    /**
     * Get Mst Transport Type
     */
    async getMstTransportTypeTransportTypeGet(requestParameters: GetMstTransportTypeTransportTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseTransportType> {
        const response = await this.getMstTransportTypeTransportTypeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ```     select         stock.company_id         ,stock.center_id         ,stock.order_date         ,stock.org_supplier_id         ,mst_supplier.supplier_name         ,mst_supplier.order_limit_time         ,count(arrival_quantity>0 or null) as today_order_count     from         func_stock_data(:company_id,:center_id,:org_supplier_id, :tr_date) as stock     LEFT JOIN mst_supplier ON mst_supplier.company_id = stock.company_id         AND mst_supplier.org_supplier_id = stock.org_supplier_id     where             order_date=:tr_date     group by         stock.company_id         ,stock.center_id         ,stock.order_date         ,stock.org_supplier_id         ,mst_supplier.supplier_name         ,mst_supplier.order_limit_time     order by order_limit_time ```
     * 発注アラート取得
     */
    async getOrderAlertOrderAlertGetRaw(requestParameters: GetOrderAlertOrderAlertGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseOrderAlert>> {
        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['pageNo'] != null) {
            queryParameters['page_no'] = requestParameters['pageNo'];
        }

        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }

        if (requestParameters['centerId'] != null) {
            queryParameters['center_id'] = requestParameters['centerId'];
        }

        if (requestParameters['orgSupplierId'] != null) {
            queryParameters['org_supplier_id'] = requestParameters['orgSupplierId'];
        }

        if (requestParameters['centerIds'] != null) {
            queryParameters['center_ids'] = requestParameters['centerIds'];
        }

        if (requestParameters['orgSupplierIds'] != null) {
            queryParameters['org_supplier_ids'] = requestParameters['orgSupplierIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/order-alert`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseOrderAlertFromJSON(jsonValue));
    }

    /**
     * ```     select         stock.company_id         ,stock.center_id         ,stock.order_date         ,stock.org_supplier_id         ,mst_supplier.supplier_name         ,mst_supplier.order_limit_time         ,count(arrival_quantity>0 or null) as today_order_count     from         func_stock_data(:company_id,:center_id,:org_supplier_id, :tr_date) as stock     LEFT JOIN mst_supplier ON mst_supplier.company_id = stock.company_id         AND mst_supplier.org_supplier_id = stock.org_supplier_id     where             order_date=:tr_date     group by         stock.company_id         ,stock.center_id         ,stock.order_date         ,stock.org_supplier_id         ,mst_supplier.supplier_name         ,mst_supplier.order_limit_time     order by order_limit_time ```
     * 発注アラート取得
     */
    async getOrderAlertOrderAlertGet(requestParameters: GetOrderAlertOrderAlertGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseOrderAlert> {
        const response = await this.getOrderAlertOrderAlertGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 需要予測詳細 商品とセンターを指定し、対象の得意先毎の出荷予測数を取得する 指定されたセンターと商品に紐づく得意先のみ取得 company_id,center_id, tr_date, item_codeは必須 ※モデル定義はship-expectedと使いまわしているので必須になっていないが、呼び出し側で指定をしないと想定通りに動かない ※ページングはなし  ```     select         jsonb_build_object(\'company_id\', ship.company_id)         || jsonb_build_object(\'center_id\', ship.center_id)         || jsonb_build_object(\'item_code\', ship.item_code)         || jsonb_build_object(\'customer_company_id\', ship.customer_company_id)         || jsonb_build_object(\'customer_company_name\', coalesce(ref_shipto_all.customer_name,\'非参加企業\'))         || jsonb_object_agg(ship.colname, quantity)  as json_rec     from func_ship_data(:company_id,:center_id, :tr_date, :item_code) ship     left join ref_shipto_all on ref_shipto_all.company_id=ship.company_id and ref_shipto_all.center_id=ship.center_id             and ref_shipto_all.customer_company_id=ship.customer_company_id and ref_shipto_all.customer_center_id=ship.customer_center_id     group by         ship.company_id         ,ship.center_id         ,ship.item_code         ,ship.customer_company_id         ,ref_shipto_all.customer_name  ```
     * 商品・センター指定 得意先毎需要予測
     */
    async getShipExpectedCustomerShipExpectedCustomerGetRaw(requestParameters: GetShipExpectedCustomerShipExpectedCustomerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseShipExpectedCustomer>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getShipExpectedCustomerShipExpectedCustomerGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['viewDateType'] != null) {
            queryParameters['view_date_type'] = requestParameters['viewDateType'];
        }

        if (requestParameters['viewUnitType'] != null) {
            queryParameters['view_unit_type'] = requestParameters['viewUnitType'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = requestParameters['startDate'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['centerId'] != null) {
            queryParameters['center_id'] = requestParameters['centerId'];
        }

        if (requestParameters['itemCode'] != null) {
            queryParameters['item_code'] = requestParameters['itemCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/ship-expected-customer`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseShipExpectedCustomerFromJSON(jsonValue));
    }

    /**
     * 需要予測詳細 商品とセンターを指定し、対象の得意先毎の出荷予測数を取得する 指定されたセンターと商品に紐づく得意先のみ取得 company_id,center_id, tr_date, item_codeは必須 ※モデル定義はship-expectedと使いまわしているので必須になっていないが、呼び出し側で指定をしないと想定通りに動かない ※ページングはなし  ```     select         jsonb_build_object(\'company_id\', ship.company_id)         || jsonb_build_object(\'center_id\', ship.center_id)         || jsonb_build_object(\'item_code\', ship.item_code)         || jsonb_build_object(\'customer_company_id\', ship.customer_company_id)         || jsonb_build_object(\'customer_company_name\', coalesce(ref_shipto_all.customer_name,\'非参加企業\'))         || jsonb_object_agg(ship.colname, quantity)  as json_rec     from func_ship_data(:company_id,:center_id, :tr_date, :item_code) ship     left join ref_shipto_all on ref_shipto_all.company_id=ship.company_id and ref_shipto_all.center_id=ship.center_id             and ref_shipto_all.customer_company_id=ship.customer_company_id and ref_shipto_all.customer_center_id=ship.customer_center_id     group by         ship.company_id         ,ship.center_id         ,ship.item_code         ,ship.customer_company_id         ,ref_shipto_all.customer_name  ```
     * 商品・センター指定 得意先毎需要予測
     */
    async getShipExpectedCustomerShipExpectedCustomerGet(requestParameters: GetShipExpectedCustomerShipExpectedCustomerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseShipExpectedCustomer> {
        const response = await this.getShipExpectedCustomerShipExpectedCustomerGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 商品またはセンターを指定し、商品・センター毎の出荷予測数を取得する 商品別の場合は、商品コードを指定する 倉庫別の場合は、センターを指定する ※ **company_idは必須 、center_id または item_codeのいずれか必須**  **※※※週単位は動かないです※※※** 需要予測検索 - 商品コードを設定するか、倉庫を設定するかの違いで、倉庫別と商品別両方取得できる！ - 起点日から、-7～14日or週の範囲を返す - レスポンスにdataとdaylistの2種類のレコードを返す - 出荷データを成型するfunc_ship_dataからデータを取得する  todo:ページングをどうするか？商品の途中で切れない todo:週単位の場合、daylistを考え直す必要あり - - **レスポンス**     - **data.list** : 取得するデータ本体         - **取得先**: func_ship_data(p_company_id int, p_center_id int, p_tr_date date, date_type text)     - **data.daylist** : listで返却された日付の設定。日付番号と対応する日付のリスト         - **取得先**: func_day_list(p_company_id int, p_center_id int, p_tr_date date, date_type text)   ```     select         jsonb_build_object(\'company_id\', ship.company_id)         || jsonb_build_object(\'center_id\', ship.center_id)         || jsonb_build_object(\'center_name\', mst_center.center_name)         || jsonb_build_object(\'item_code\', ship.item_code)         || jsonb_build_object(\'item_name\', mst_item.item_name)         || jsonb_build_object(\'expected_rank\', max(expected_rank))         || jsonb_object_agg(ship.colname, quantity)  as json_rec     from func_ship_data(:company_id,:center_id, :tr_date, :item_code) ship     inner join mst_item on mst_item.company_id = ship.company_id      inner join ref_mst_item on ref_mst_item.company_id = mst_item.company_id                             AND ref_mst_item.org_item_code = mst_item.org_item_code                             AND ref_mst_item.item_code = ship.item_code     left join mst_center on mst_center.company_id =ship.company_id and mst_center.center_id  =ship.center_id     left join ref_shipto_all on ref_shipto_all.company_id=ship.company_id and ref_shipto_all.center_id=ship.center_id             and ref_shipto_all.customer_company_id=ship.customer_company_id and ref_shipto_all.customer_center_id=ship.customer_center_id     group by         ship.company_id         ,ship.center_id         , mst_center.center_name         ,ship.item_code         ,mst_item.item_name  ```
     * 需要予測検索 商品・センター毎
     */
    async getShipExpectedShipExpectedGetRaw(requestParameters: GetShipExpectedShipExpectedGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseShipExpected>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getShipExpectedShipExpectedGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['viewDateType'] != null) {
            queryParameters['view_date_type'] = requestParameters['viewDateType'];
        }

        if (requestParameters['viewUnitType'] != null) {
            queryParameters['view_unit_type'] = requestParameters['viewUnitType'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = requestParameters['startDate'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['centerId'] != null) {
            queryParameters['center_id'] = requestParameters['centerId'];
        }

        if (requestParameters['itemCode'] != null) {
            queryParameters['item_code'] = requestParameters['itemCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/ship-expected`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseShipExpectedFromJSON(jsonValue));
    }

    /**
     * 商品またはセンターを指定し、商品・センター毎の出荷予測数を取得する 商品別の場合は、商品コードを指定する 倉庫別の場合は、センターを指定する ※ **company_idは必須 、center_id または item_codeのいずれか必須**  **※※※週単位は動かないです※※※** 需要予測検索 - 商品コードを設定するか、倉庫を設定するかの違いで、倉庫別と商品別両方取得できる！ - 起点日から、-7～14日or週の範囲を返す - レスポンスにdataとdaylistの2種類のレコードを返す - 出荷データを成型するfunc_ship_dataからデータを取得する  todo:ページングをどうするか？商品の途中で切れない todo:週単位の場合、daylistを考え直す必要あり - - **レスポンス**     - **data.list** : 取得するデータ本体         - **取得先**: func_ship_data(p_company_id int, p_center_id int, p_tr_date date, date_type text)     - **data.daylist** : listで返却された日付の設定。日付番号と対応する日付のリスト         - **取得先**: func_day_list(p_company_id int, p_center_id int, p_tr_date date, date_type text)   ```     select         jsonb_build_object(\'company_id\', ship.company_id)         || jsonb_build_object(\'center_id\', ship.center_id)         || jsonb_build_object(\'center_name\', mst_center.center_name)         || jsonb_build_object(\'item_code\', ship.item_code)         || jsonb_build_object(\'item_name\', mst_item.item_name)         || jsonb_build_object(\'expected_rank\', max(expected_rank))         || jsonb_object_agg(ship.colname, quantity)  as json_rec     from func_ship_data(:company_id,:center_id, :tr_date, :item_code) ship     inner join mst_item on mst_item.company_id = ship.company_id      inner join ref_mst_item on ref_mst_item.company_id = mst_item.company_id                             AND ref_mst_item.org_item_code = mst_item.org_item_code                             AND ref_mst_item.item_code = ship.item_code     left join mst_center on mst_center.company_id =ship.company_id and mst_center.center_id  =ship.center_id     left join ref_shipto_all on ref_shipto_all.company_id=ship.company_id and ref_shipto_all.center_id=ship.center_id             and ref_shipto_all.customer_company_id=ship.customer_company_id and ref_shipto_all.customer_center_id=ship.customer_center_id     group by         ship.company_id         ,ship.center_id         , mst_center.center_name         ,ship.item_code         ,mst_item.item_name  ```
     * 需要予測検索 商品・センター毎
     */
    async getShipExpectedShipExpectedGet(requestParameters: GetShipExpectedShipExpectedGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseShipExpected> {
        const response = await this.getShipExpectedShipExpectedGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * センター商品別入出荷在庫検索（表形式)
     * センター商品別入出荷在庫検索（表形式）
     */
    async getStockStockGetRaw(requestParameters: GetStockStockGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseStock>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getStockStockGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['centerId'] != null) {
            queryParameters['center_id'] = requestParameters['centerId'];
        }

        if (requestParameters['centerIds'] != null) {
            queryParameters['center_ids'] = requestParameters['centerIds'];
        }

        if (requestParameters['orgCenterId'] != null) {
            queryParameters['org_center_id'] = requestParameters['orgCenterId'];
        }

        if (requestParameters['orgSupplierId'] != null) {
            queryParameters['org_supplier_id'] = requestParameters['orgSupplierId'];
        }

        if (requestParameters['orgSupplierIds'] != null) {
            queryParameters['org_supplier_ids'] = requestParameters['orgSupplierIds'];
        }

        if (requestParameters['itemCode'] != null) {
            queryParameters['item_code'] = requestParameters['itemCode'];
        }

        if (requestParameters['itemCodes'] != null) {
            queryParameters['item_codes'] = requestParameters['itemCodes'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = requestParameters['startDate'];
        }

        if (requestParameters['viewUnitType'] != null) {
            queryParameters['view_unit_type'] = requestParameters['viewUnitType'];
        }

        if (requestParameters['dateRange'] != null) {
            queryParameters['date_range'] = requestParameters['dateRange'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['end_date'] = requestParameters['endDate'];
        }

        if (requestParameters['renewal'] != null) {
            queryParameters['renewal'] = requestParameters['renewal'];
        }

        if (requestParameters['orderPlanFlg'] != null) {
            queryParameters['order_plan_flg'] = requestParameters['orderPlanFlg'];
        }

        if (requestParameters['getPeriodDataFlg'] != null) {
            queryParameters['get_period_data_flg'] = requestParameters['getPeriodDataFlg'];
        }

        if (requestParameters['startDateTypeCode'] != null) {
            queryParameters['start_date_type_code'] = requestParameters['startDateTypeCode'];
        }

        if (requestParameters['endDateTypeCode'] != null) {
            queryParameters['end_date_type_code'] = requestParameters['endDateTypeCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/stock`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStockFromJSON(jsonValue));
    }

    /**
     * センター商品別入出荷在庫検索（表形式)
     * センター商品別入出荷在庫検索（表形式）
     */
    async getStockStockGet(requestParameters: GetStockStockGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseStock> {
        const response = await this.getStockStockGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 区分マスタ検索
     * 区分マスタ
     */
    async getSysTypecodeTypecodeGetRaw(requestParameters: GetSysTypecodeTypecodeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseTypecode>> {
        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['pageNo'] != null) {
            queryParameters['page_no'] = requestParameters['pageNo'];
        }

        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/typecode`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseTypecodeFromJSON(jsonValue));
    }

    /**
     * 区分マスタ検索
     * 区分マスタ
     */
    async getSysTypecodeTypecodeGet(requestParameters: GetSysTypecodeTypecodeGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseTypecode> {
        const response = await this.getSysTypecodeTypecodeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * カレンダーセンター仕入先更新
     */
    async masterCalendarCenterSupplierUpdateCalendarCenterSupplierUpdatePostRaw(requestParameters: MasterCalendarCenterSupplierUpdateCalendarCenterSupplierUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUpdate>> {
        if (requestParameters['mstCalendarCenterSupplierUpdate'] == null) {
            throw new runtime.RequiredError(
                'mstCalendarCenterSupplierUpdate',
                'Required parameter "mstCalendarCenterSupplierUpdate" was null or undefined when calling masterCalendarCenterSupplierUpdateCalendarCenterSupplierUpdatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/calendar-center-supplier/update`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MstCalendarCenterSupplierUpdateToJSON(requestParameters['mstCalendarCenterSupplierUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUpdateFromJSON(jsonValue));
    }

    /**
     * カレンダーセンター仕入先更新
     */
    async masterCalendarCenterSupplierUpdateCalendarCenterSupplierUpdatePost(requestParameters: MasterCalendarCenterSupplierUpdateCalendarCenterSupplierUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUpdate> {
        const response = await this.masterCalendarCenterSupplierUpdateCalendarCenterSupplierUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Master Calendar Update
     */
    async masterCalendarUpdateMstCalendarUpdatePostRaw(requestParameters: MasterCalendarUpdateMstCalendarUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUpdate>> {
        if (requestParameters['mstCalendarUpdate'] == null) {
            throw new runtime.RequiredError(
                'mstCalendarUpdate',
                'Required parameter "mstCalendarUpdate" was null or undefined when calling masterCalendarUpdateMstCalendarUpdatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/mst-calendar/update`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MstCalendarUpdateToJSON(requestParameters['mstCalendarUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUpdateFromJSON(jsonValue));
    }

    /**
     * Master Calendar Update
     */
    async masterCalendarUpdateMstCalendarUpdatePost(requestParameters: MasterCalendarUpdateMstCalendarUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUpdate> {
        const response = await this.masterCalendarUpdateMstCalendarUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Master Center Stock Item Update
     */
    async masterCenterStockItemUpdateMstCenterStockItemUpdatePostRaw(requestParameters: MasterCenterStockItemUpdateMstCenterStockItemUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUpdate>> {
        if (requestParameters['mstCenterStockItemUpdate'] == null) {
            throw new runtime.RequiredError(
                'mstCenterStockItemUpdate',
                'Required parameter "mstCenterStockItemUpdate" was null or undefined when calling masterCenterStockItemUpdateMstCenterStockItemUpdatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/mst-center-stock-item/update`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MstCenterStockItemUpdateToJSON(requestParameters['mstCenterStockItemUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUpdateFromJSON(jsonValue));
    }

    /**
     * Master Center Stock Item Update
     */
    async masterCenterStockItemUpdateMstCenterStockItemUpdatePost(requestParameters: MasterCenterStockItemUpdateMstCenterStockItemUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUpdate> {
        const response = await this.masterCenterStockItemUpdateMstCenterStockItemUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 入出荷数量調整更新
     */
    async masterCenterUpdateMasterCenterUpdatePostRaw(requestParameters: MasterCenterUpdateMasterCenterUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUpdate>> {
        if (requestParameters['centerUpdate'] == null) {
            throw new runtime.RequiredError(
                'centerUpdate',
                'Required parameter "centerUpdate" was null or undefined when calling masterCenterUpdateMasterCenterUpdatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/master-center/update`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CenterUpdateToJSON(requestParameters['centerUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUpdateFromJSON(jsonValue));
    }

    /**
     * 入出荷数量調整更新
     */
    async masterCenterUpdateMasterCenterUpdatePost(requestParameters: MasterCenterUpdateMasterCenterUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUpdate> {
        const response = await this.masterCenterUpdateMasterCenterUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Master Customer Center Update
     */
    async masterCustomerCenterUpdateMstCustomerCenterUpdatePostRaw(requestParameters: MasterCustomerCenterUpdateMstCustomerCenterUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUpdate>> {
        if (requestParameters['mstCustomerCenterUpdate'] == null) {
            throw new runtime.RequiredError(
                'mstCustomerCenterUpdate',
                'Required parameter "mstCustomerCenterUpdate" was null or undefined when calling masterCustomerCenterUpdateMstCustomerCenterUpdatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/mst-customer-center/update`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MstCustomerCenterUpdateToJSON(requestParameters['mstCustomerCenterUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUpdateFromJSON(jsonValue));
    }

    /**
     * Master Customer Center Update
     */
    async masterCustomerCenterUpdateMstCustomerCenterUpdatePost(requestParameters: MasterCustomerCenterUpdateMstCustomerCenterUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUpdate> {
        const response = await this.masterCustomerCenterUpdateMstCustomerCenterUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 入出荷数量調整更新
     */
    async masterCustomerUpdateMasterCustomerUpdatePostRaw(requestParameters: MasterCustomerUpdateMasterCustomerUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUpdate>> {
        if (requestParameters['mstCustomerUpdate'] == null) {
            throw new runtime.RequiredError(
                'mstCustomerUpdate',
                'Required parameter "mstCustomerUpdate" was null or undefined when calling masterCustomerUpdateMasterCustomerUpdatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/master-customer/update`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MstCustomerUpdateToJSON(requestParameters['mstCustomerUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUpdateFromJSON(jsonValue));
    }

    /**
     * 入出荷数量調整更新
     */
    async masterCustomerUpdateMasterCustomerUpdatePost(requestParameters: MasterCustomerUpdateMasterCustomerUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUpdate> {
        const response = await this.masterCustomerUpdateMasterCustomerUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Master Item Update
     */
    async masterItemUpdateMasterItemUpdatePostRaw(requestParameters: MasterItemUpdateMasterItemUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUpdate>> {
        if (requestParameters['masterItemUpdate'] == null) {
            throw new runtime.RequiredError(
                'masterItemUpdate',
                'Required parameter "masterItemUpdate" was null or undefined when calling masterItemUpdateMasterItemUpdatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/master-item/update`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MasterItemUpdateToJSON(requestParameters['masterItemUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUpdateFromJSON(jsonValue));
    }

    /**
     * Master Item Update
     */
    async masterItemUpdateMasterItemUpdatePost(requestParameters: MasterItemUpdateMasterItemUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUpdate> {
        const response = await this.masterItemUpdateMasterItemUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 入出荷数量調整更新
     */
    async masterSupplierUpdateMasterSupplierUpdatePostRaw(requestParameters: MasterSupplierUpdateMasterSupplierUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUpdate>> {
        if (requestParameters['mstSupplierUpate'] == null) {
            throw new runtime.RequiredError(
                'mstSupplierUpate',
                'Required parameter "mstSupplierUpate" was null or undefined when calling masterSupplierUpdateMasterSupplierUpdatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/master-supplier/update`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MstSupplierUpateToJSON(requestParameters['mstSupplierUpate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUpdateFromJSON(jsonValue));
    }

    /**
     * 入出荷数量調整更新
     */
    async masterSupplierUpdateMasterSupplierUpdatePost(requestParameters: MasterSupplierUpdateMasterSupplierUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUpdate> {
        const response = await this.masterSupplierUpdateMasterSupplierUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Master Transport Relation Update
     */
    async masterTransportRelationUpdateMstTransportRelationUpdatePostRaw(requestParameters: MasterTransportRelationUpdateMstTransportRelationUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUpdate>> {
        if (requestParameters['mstTransportRelationUpdate'] == null) {
            throw new runtime.RequiredError(
                'mstTransportRelationUpdate',
                'Required parameter "mstTransportRelationUpdate" was null or undefined when calling masterTransportRelationUpdateMstTransportRelationUpdatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/mst-transport-relation/update`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MstTransportRelationUpdateToJSON(requestParameters['mstTransportRelationUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUpdateFromJSON(jsonValue));
    }

    /**
     * Master Transport Relation Update
     */
    async masterTransportRelationUpdateMstTransportRelationUpdatePost(requestParameters: MasterTransportRelationUpdateMstTransportRelationUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUpdate> {
        const response = await this.masterTransportRelationUpdateMstTransportRelationUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Master Transport Type Update
     */
    async masterTransportTypeUpdateMstTransportTypeUpdatePostRaw(requestParameters: MasterTransportTypeUpdateMstTransportTypeUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUpdate>> {
        if (requestParameters['mstTransportTypeUpdate'] == null) {
            throw new runtime.RequiredError(
                'mstTransportTypeUpdate',
                'Required parameter "mstTransportTypeUpdate" was null or undefined when calling masterTransportTypeUpdateMstTransportTypeUpdatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/mst-transport-type/update`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MstTransportTypeUpdateToJSON(requestParameters['mstTransportTypeUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUpdateFromJSON(jsonValue));
    }

    /**
     * Master Transport Type Update
     */
    async masterTransportTypeUpdateMstTransportTypeUpdatePost(requestParameters: MasterTransportTypeUpdateMstTransportTypeUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUpdate> {
        const response = await this.masterTransportTypeUpdateMstTransportTypeUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mst Center Supplier Update
     */
    async mstCenterSupplierUpdateCenterSupplierUpdatePostRaw(requestParameters: MstCenterSupplierUpdateCenterSupplierUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUpdate>> {
        if (requestParameters['mstCenterSupplierUpdate'] == null) {
            throw new runtime.RequiredError(
                'mstCenterSupplierUpdate',
                'Required parameter "mstCenterSupplierUpdate" was null or undefined when calling mstCenterSupplierUpdateCenterSupplierUpdatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/center-supplier/update`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MstCenterSupplierUpdateToJSON(requestParameters['mstCenterSupplierUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUpdateFromJSON(jsonValue));
    }

    /**
     * Mst Center Supplier Update
     */
    async mstCenterSupplierUpdateCenterSupplierUpdatePost(requestParameters: MstCenterSupplierUpdateCenterSupplierUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUpdate> {
        const response = await this.mstCenterSupplierUpdateCenterSupplierUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 平準化結果更新API  平準化計算結果をt_stock_centerテーブルに一括更新します。  更新対象項目: - stock_quantity: 在庫数 - stock_days: 在庫日数 - order_quantity_recommend: 発注推奨値 - order_recommend_calc_datetime: 発注推奨算出日時  注意事項: - 既存レコードのみ更新（INSERT不要） - PK（company_id, center_id, item_code, rec_date）で対象レコードを特定 - 平準化計算期間全体のデータが更新対象
     * 平準化結果更新
     */
    async optimizeResultUpdateStockUpdatePostRaw(requestParameters: OptimizeResultUpdateStockUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUpdate>> {
        if (requestParameters['stockUpdate'] == null) {
            throw new runtime.RequiredError(
                'stockUpdate',
                'Required parameter "stockUpdate" was null or undefined when calling optimizeResultUpdateStockUpdatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/stock/update`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StockUpdateToJSON(requestParameters['stockUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUpdateFromJSON(jsonValue));
    }

    /**
     * 平準化結果更新API  平準化計算結果をt_stock_centerテーブルに一括更新します。  更新対象項目: - stock_quantity: 在庫数 - stock_days: 在庫日数 - order_quantity_recommend: 発注推奨値 - order_recommend_calc_datetime: 発注推奨算出日時  注意事項: - 既存レコードのみ更新（INSERT不要） - PK（company_id, center_id, item_code, rec_date）で対象レコードを特定 - 平準化計算期間全体のデータが更新対象
     * 平準化結果更新
     */
    async optimizeResultUpdateStockUpdatePost(requestParameters: OptimizeResultUpdateStockUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUpdate> {
        const response = await this.optimizeResultUpdateStockUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 発注計画輸送ロット更新API - data     - stockPlanList: list[StockPlan] = Field(description=\'発注日の確定入荷数\')         - t_stock_planにUpsert         - デフォルトは、本日発注分の入荷日(rec_date)分         - （例：木曜日に、土曜と月曜の分を発注する場合は、土曜と月曜2日分）         - 入荷数として確定した状態にするため、変更有無に関わらず、t_stock_plan.arrival_quantity_planに登録する         - 入荷日の変更=対象日のarrival_quantity_planはゼロで確定する     - orderPlanTransportLotList: list[orderPlanTransportLot] = Field(description=\'発注日の確定輸送ロット\')         - t_order_plan_transport_lotの更新             - company_id,center_id,org_supplier_id,rec_dateでDeleteInsert             - ※deleteは、stockPlanListからキーを取得         - stockPlanListと同じ日(rec_date)のリスト     - pendingOrderNextDay: list[PendingOrderNextDay] = Field(description=\'調整日の発注数（未確定）\')          - t_stock_plan_temp_next_batchの更新             - company_id,center_id,rec_dateでDeleteInsert         - 積載率最適化のために、次の日の発注分から調整を行った結果         - 発注日の次の日のみ         - (例：木曜日に、土曜と月曜の分を発注する場合は、火曜の分)         - 次の日の発注分の調整は、確定ではないが、調整内容は保存しておきたい
     * 発注計画輸送ロット更新
     */
    async orderPlanTransportLotUpdateOrderPlanTransportLotUpdatePostRaw(requestParameters: OrderPlanTransportLotUpdateOrderPlanTransportLotUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUpdate>> {
        if (requestParameters['orderPlanTransportLotUpdate'] == null) {
            throw new runtime.RequiredError(
                'orderPlanTransportLotUpdate',
                'Required parameter "orderPlanTransportLotUpdate" was null or undefined when calling orderPlanTransportLotUpdateOrderPlanTransportLotUpdatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/order-plan-transport-lot/update`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderPlanTransportLotUpdateToJSON(requestParameters['orderPlanTransportLotUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUpdateFromJSON(jsonValue));
    }

    /**
     * 発注計画輸送ロット更新API - data     - stockPlanList: list[StockPlan] = Field(description=\'発注日の確定入荷数\')         - t_stock_planにUpsert         - デフォルトは、本日発注分の入荷日(rec_date)分         - （例：木曜日に、土曜と月曜の分を発注する場合は、土曜と月曜2日分）         - 入荷数として確定した状態にするため、変更有無に関わらず、t_stock_plan.arrival_quantity_planに登録する         - 入荷日の変更=対象日のarrival_quantity_planはゼロで確定する     - orderPlanTransportLotList: list[orderPlanTransportLot] = Field(description=\'発注日の確定輸送ロット\')         - t_order_plan_transport_lotの更新             - company_id,center_id,org_supplier_id,rec_dateでDeleteInsert             - ※deleteは、stockPlanListからキーを取得         - stockPlanListと同じ日(rec_date)のリスト     - pendingOrderNextDay: list[PendingOrderNextDay] = Field(description=\'調整日の発注数（未確定）\')          - t_stock_plan_temp_next_batchの更新             - company_id,center_id,rec_dateでDeleteInsert         - 積載率最適化のために、次の日の発注分から調整を行った結果         - 発注日の次の日のみ         - (例：木曜日に、土曜と月曜の分を発注する場合は、火曜の分)         - 次の日の発注分の調整は、確定ではないが、調整内容は保存しておきたい
     * 発注計画輸送ロット更新
     */
    async orderPlanTransportLotUpdateOrderPlanTransportLotUpdatePost(requestParameters: OrderPlanTransportLotUpdateOrderPlanTransportLotUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUpdate> {
        const response = await this.orderPlanTransportLotUpdateOrderPlanTransportLotUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ユーザ企業検索 - **テーブル**: mst_company - 削除フラグを追加     - delete_datetime is null as delete_flg - ログインユーザーの権限によって、検索に使うcompany_idを変更     - x_user_auth=99 : company_idはパラメーターで渡されたID     - それ以外 : x_company_id
     * ユーザ企業検索
     */
    async readCompanyCompanySearchGetRaw(requestParameters: ReadCompanyCompanySearchGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseCompany>> {
        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['pageNo'] != null) {
            queryParameters['page_no'] = requestParameters['pageNo'];
        }

        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['tenantId'] != null) {
            queryParameters['tenant_id'] = requestParameters['tenantId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/company/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseCompanyFromJSON(jsonValue));
    }

    /**
     * ユーザ企業検索 - **テーブル**: mst_company - 削除フラグを追加     - delete_datetime is null as delete_flg - ログインユーザーの権限によって、検索に使うcompany_idを変更     - x_user_auth=99 : company_idはパラメーターで渡されたID     - それ以外 : x_company_id
     * ユーザ企業検索
     */
    async readCompanyCompanySearchGet(requestParameters: ReadCompanyCompanySearchGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseCompany> {
        const response = await this.readCompanyCompanySearchGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Authヘッダーを元にIdentity Platformからログインユーザー情報を取得 ユーザーIDを元にread_usersからユーザー情報を返す
     * Read Users Me
     */
    async readUsersMeLoginUserInfoGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLoginUser>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/login-user-info`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLoginUserFromJSON(jsonValue));
    }

    /**
     * Authヘッダーを元にIdentity Platformからログインユーザー情報を取得 ユーザーIDを元にread_usersからユーザー情報を返す
     * Read Users Me
     */
    async readUsersMeLoginUserInfoGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLoginUser> {
        const response = await this.readUsersMeLoginUserInfoGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * ユーザマスタ: - **テーブル**: mst_user - ログインユーザーの権限によって、検索に使うcompany_idを変更     - x_user_auth=99 : company_idはパラメーターで渡されたID     - それ以外 : x_company_id
     * ユーザ
     */
    async readUsersUserSearchGetRaw(requestParameters: ReadUsersUserSearchGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUserSearch>> {
        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['pageNo'] != null) {
            queryParameters['page_no'] = requestParameters['pageNo'];
        }

        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['userMail'] != null) {
            queryParameters['user_mail'] = requestParameters['userMail'];
        }

        if (requestParameters['tenantId'] != null) {
            queryParameters['tenant_id'] = requestParameters['tenantId'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUserSearchFromJSON(jsonValue));
    }

    /**
     * ユーザマスタ: - **テーブル**: mst_user - ログインユーザーの権限によって、検索に使うcompany_idを変更     - x_user_auth=99 : company_idはパラメーターで渡されたID     - それ以外 : x_company_id
     * ユーザ
     */
    async readUsersUserSearchGet(requestParameters: ReadUsersUserSearchGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUserSearch> {
        const response = await this.readUsersUserSearchGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * - todo:ワークフロー実施中の場合は、エラーを通知して終了(2024-03 ph3機能追加)  1: data_type=\'mst_center\'の場合  アップロードされたファイルから、センターマスタを更新 ファイルはCSV(.csv)、またはエクセル(.xlsx)。ファイルの拡張子から判断する modelCenter.CenterUpdateIFで入力内容のチェック company_id・org_center_idで更新or新規登録(ユニークキーを使用) delete_flg=trueの場合は、削除日時にシステム日付を設定。delete_flg=falseの場合は削除日時にNULLを設定 結果をResponseUpdateで返す  データ取込み共通仕様参照 https://jdsc.atlassian.net/wiki/spaces/WSK/pages/2773319747#%E5%85%B1%E9%80%9A   2: data_type=\'mst_center\'以外の場合  ストレージにファイルをアップロード - ストレージ領域の対象のフォルダに、ファイル名を変更して保存     - フォルダ: x_tenant_id     - ファイル名: {data_type}_{ファイルを受信した日時をyyyymmddhhmmss形式で}_{元のファイル名} - sys_infomessageに受付記録を登録  |項目名|フィールド名|登録内容| |:----|:----|:----| |PSI企業ID|company_id|x_company_id| |処理区分|process_type|\'101\'| |対象|target|data_type| |出力日時|info_time|current_timestamp| |メッセージ区分|info_type|\'info\'| |メッセージ|message|アップロードを受付けました。処理が完了までしばらくお待ちください。\'| |登録日時|insert_datetime|current_timestamp| |登録ユーザー|insert_user|x_user_id| |更新日時|update_datetime|current_timestamp| |更新ユーザー|update_user|x_user_id|
     * データファイルのアップロード
     */
    async savePostUploadDataTypePostRaw(requestParameters: SavePostUploadDataTypePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUpdate>> {
        if (requestParameters['dataType'] == null) {
            throw new runtime.RequiredError(
                'dataType',
                'Required parameter "dataType" was null or undefined when calling savePostUploadDataTypePost().'
            );
        }

        if (requestParameters['postedFile'] == null) {
            throw new runtime.RequiredError(
                'postedFile',
                'Required parameter "postedFile" was null or undefined when calling savePostUploadDataTypePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['postedFile'] != null) {
            formParams.append('posted_file', requestParameters['postedFile'] as any);
        }


        let urlPath = `/upload/{data_type}`;
        urlPath = urlPath.replace(`{${"data_type"}}`, encodeURIComponent(String(requestParameters['dataType'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUpdateFromJSON(jsonValue));
    }

    /**
     * - todo:ワークフロー実施中の場合は、エラーを通知して終了(2024-03 ph3機能追加)  1: data_type=\'mst_center\'の場合  アップロードされたファイルから、センターマスタを更新 ファイルはCSV(.csv)、またはエクセル(.xlsx)。ファイルの拡張子から判断する modelCenter.CenterUpdateIFで入力内容のチェック company_id・org_center_idで更新or新規登録(ユニークキーを使用) delete_flg=trueの場合は、削除日時にシステム日付を設定。delete_flg=falseの場合は削除日時にNULLを設定 結果をResponseUpdateで返す  データ取込み共通仕様参照 https://jdsc.atlassian.net/wiki/spaces/WSK/pages/2773319747#%E5%85%B1%E9%80%9A   2: data_type=\'mst_center\'以外の場合  ストレージにファイルをアップロード - ストレージ領域の対象のフォルダに、ファイル名を変更して保存     - フォルダ: x_tenant_id     - ファイル名: {data_type}_{ファイルを受信した日時をyyyymmddhhmmss形式で}_{元のファイル名} - sys_infomessageに受付記録を登録  |項目名|フィールド名|登録内容| |:----|:----|:----| |PSI企業ID|company_id|x_company_id| |処理区分|process_type|\'101\'| |対象|target|data_type| |出力日時|info_time|current_timestamp| |メッセージ区分|info_type|\'info\'| |メッセージ|message|アップロードを受付けました。処理が完了までしばらくお待ちください。\'| |登録日時|insert_datetime|current_timestamp| |登録ユーザー|insert_user|x_user_id| |更新日時|update_datetime|current_timestamp| |更新ユーザー|update_user|x_user_id|
     * データファイルのアップロード
     */
    async savePostUploadDataTypePost(requestParameters: SavePostUploadDataTypePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUpdate> {
        const response = await this.savePostUploadDataTypePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 計算除外フラグ更新API
     * 計算除外フラグ更新
     */
    async shipExclusionUpdateShipExclusionUpdatePostRaw(requestParameters: ShipExclusionUpdateShipExclusionUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUpdate>> {
        if (requestParameters['shipExclusionUpdate'] == null) {
            throw new runtime.RequiredError(
                'shipExclusionUpdate',
                'Required parameter "shipExclusionUpdate" was null or undefined when calling shipExclusionUpdateShipExclusionUpdatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/ship-exclusion/update`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShipExclusionUpdateToJSON(requestParameters['shipExclusionUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUpdateFromJSON(jsonValue));
    }

    /**
     * 計算除外フラグ更新API
     * 計算除外フラグ更新
     */
    async shipExclusionUpdateShipExclusionUpdatePost(requestParameters: ShipExclusionUpdateShipExclusionUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUpdate> {
        const response = await this.shipExclusionUpdateShipExclusionUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 入出荷数量調整更新API
     * 入出荷数量調整更新
     */
    async stockPlanUpdateStockPlanUpdatePostRaw(requestParameters: StockPlanUpdateStockPlanUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUpdate>> {
        if (requestParameters['stockPlanUpdate'] == null) {
            throw new runtime.RequiredError(
                'stockPlanUpdate',
                'Required parameter "stockPlanUpdate" was null or undefined when calling stockPlanUpdateStockPlanUpdatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/stock-plan/update`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StockPlanUpdateToJSON(requestParameters['stockPlanUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUpdateFromJSON(jsonValue));
    }

    /**
     * 入出荷数量調整更新API
     * 入出荷数量調整更新
     */
    async stockPlanUpdateStockPlanUpdatePost(requestParameters: StockPlanUpdateStockPlanUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUpdate> {
        const response = await this.stockPlanUpdateStockPlanUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 複数商品含むファイルをアップロードして、stock_updateの処理を実行  - todo:ワークフロー実施中の場合は、エラーを通知して終了(2024-03 ph3機能追加) 1. ファイルから company_id, center_idの組み合わせをピックアップ    本日中に編集、アップロードされたファイルのみを取り扱う    ファイル内の date_type=today の rec_date が本日日付と一致しないものはエラーとする 2. 現在の登録内容と比較するためにstockの取得 select * from func_stock_data(company_id, center_id, null, null, 本日日付)  order by rec_date 3. 以下の場合に、modelStock.StockUpdateのレコードを作成して、stock.upsert_stockを実施     - stockのenable_update_arrival=trueのレコードについて、ファイルのarrival_quantityの値が異なる場合     - stockのenable_update_ship=trueのレコードについて、ファイルのship_quantityの値が異なる場合
     * 入出荷数量調整更新(アップロード)
     */
    async stockUpdateUploadStockPlanUploadPostRaw(requestParameters: StockUpdateUploadStockPlanUploadPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUpdate>> {
        if (requestParameters['postedFile'] == null) {
            throw new runtime.RequiredError(
                'postedFile',
                'Required parameter "postedFile" was null or undefined when calling stockUpdateUploadStockPlanUploadPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['postedFile'] != null) {
            formParams.append('posted_file', requestParameters['postedFile'] as any);
        }


        let urlPath = `/stock-plan/upload`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUpdateFromJSON(jsonValue));
    }

    /**
     * 複数商品含むファイルをアップロードして、stock_updateの処理を実行  - todo:ワークフロー実施中の場合は、エラーを通知して終了(2024-03 ph3機能追加) 1. ファイルから company_id, center_idの組み合わせをピックアップ    本日中に編集、アップロードされたファイルのみを取り扱う    ファイル内の date_type=today の rec_date が本日日付と一致しないものはエラーとする 2. 現在の登録内容と比較するためにstockの取得 select * from func_stock_data(company_id, center_id, null, null, 本日日付)  order by rec_date 3. 以下の場合に、modelStock.StockUpdateのレコードを作成して、stock.upsert_stockを実施     - stockのenable_update_arrival=trueのレコードについて、ファイルのarrival_quantityの値が異なる場合     - stockのenable_update_ship=trueのレコードについて、ファイルのship_quantityの値が異なる場合
     * 入出荷数量調整更新(アップロード)
     */
    async stockUpdateUploadStockPlanUploadPost(requestParameters: StockUpdateUploadStockPlanUploadPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUpdate> {
        const response = await this.stockUpdateUploadStockPlanUploadPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ユーザ企業更新 - **テーブル**: mst_company - company_idはパラメーターで渡されたIDを使用 - ログインユーザーの権限チェック 作成不可の場合は権限エラー     - x_user_auth=99 : 変更可     - x_user_auth=9 : company_id=x_company_idの場合のみ変更可     - それ以外 : 変更不可 - delete_flg=trueの場合は削除日付に本日日付を設定、falseの場合は削除日付にnullを設定
     * ユーザ企業更新
     */
    async updateCompanyCompanyUpdatePostRaw(requestParameters: UpdateCompanyCompanyUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUpdate>> {
        if (requestParameters['companyInput'] == null) {
            throw new runtime.RequiredError(
                'companyInput',
                'Required parameter "companyInput" was null or undefined when calling updateCompanyCompanyUpdatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/company/update`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompanyInputToJSON(requestParameters['companyInput']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUpdateFromJSON(jsonValue));
    }

    /**
     * ユーザ企業更新 - **テーブル**: mst_company - company_idはパラメーターで渡されたIDを使用 - ログインユーザーの権限チェック 作成不可の場合は権限エラー     - x_user_auth=99 : 変更可     - x_user_auth=9 : company_id=x_company_idの場合のみ変更可     - それ以外 : 変更不可 - delete_flg=trueの場合は削除日付に本日日付を設定、falseの場合は削除日付にnullを設定
     * ユーザ企業更新
     */
    async updateCompanyCompanyUpdatePost(requestParameters: UpdateCompanyCompanyUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUpdate> {
        const response = await this.updateCompanyCompanyUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ユーザマスタ: - **テーブル**: mst_user - company_idはパラメーターで渡されたIDを使用 - ログインユーザーの権限チェック 変更不可の場合は権限エラー     - x_user_auth=99 : 変更可     - x_user_auth=9 : company_id=x_company_idの場合のみ変更可     - それ以外 : x_user_id=user_idの場合のみ変更可 - メールアドレスの変更を行った場合     - 同一テナント内に、おなじメールアドレスのユーザーが存在しないことを確認（存在する場合はエラー）     - Identity Platformの更新
     * ユーザ更新
     */
    async updateUserUserUpdatePostRaw(requestParameters: UpdateUserUserUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUserUpdate>> {
        if (requestParameters['mstUserInput'] == null) {
            throw new runtime.RequiredError(
                'mstUserInput',
                'Required parameter "mstUserInput" was null or undefined when calling updateUserUserUpdatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xCompanyId'] != null) {
            headerParameters['x-company-id'] = String(requestParameters['xCompanyId']);
        }

        if (requestParameters['xTenantId'] != null) {
            headerParameters['x-tenant-id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xUserId'] != null) {
            headerParameters['x-user-id'] = String(requestParameters['xUserId']);
        }

        if (requestParameters['xSystemDate'] != null) {
            headerParameters['x-system-date'] = String(requestParameters['xSystemDate']);
        }

        if (requestParameters['xUserAuth'] != null) {
            headerParameters['x-user-auth'] = String(requestParameters['xUserAuth']);
        }

        if (requestParameters['xSystemStatus'] != null) {
            headerParameters['x-system-status'] = String(requestParameters['xSystemStatus']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }


        let urlPath = `/user/update`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MstUserInputToJSON(requestParameters['mstUserInput']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUserUpdateFromJSON(jsonValue));
    }

    /**
     * ユーザマスタ: - **テーブル**: mst_user - company_idはパラメーターで渡されたIDを使用 - ログインユーザーの権限チェック 変更不可の場合は権限エラー     - x_user_auth=99 : 変更可     - x_user_auth=9 : company_id=x_company_idの場合のみ変更可     - それ以外 : x_user_id=user_idの場合のみ変更可 - メールアドレスの変更を行った場合     - 同一テナント内に、おなじメールアドレスのユーザーが存在しないことを確認（存在する場合はエラー）     - Identity Platformの更新
     * ユーザ更新
     */
    async updateUserUserUpdatePost(requestParameters: UpdateUserUserUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUserUpdate> {
        const response = await this.updateUserUserUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
